import React, { useEffect, useRef, useState } from "react";
import AccidentDetails from "./AccidentDetails";
import AccidentInformation from "./AccidentInfo";
import EmployeeInformation from "./EmployeeInfo";
import EmployerInformation from "./EmployerInfo";
import ReturnToWorkInformation from "./ReturnToWorkInfo";
import Airsteps from "./Steps";
import validation from "../../utilities/validation";
import * as utilities from "../../utilities/utils";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import * as stdActions from "../../redux/actions/stdAction";
import ApplicationPending from '../../containers/PendingApplication'
import swal from 'sweetalert';
import history from "../../utilities/history";
import ManagerDetailModal from "../../containers/Std/ManagerDetailModal";
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";

import {
  ALPHANUMERICREGEX,
  format,
  POST_CODE_REGEX,
  NUMBERREGEX,
  NUMBER_FORMAT_REGEX,
  PREFERED_LANGUAGE_KEYS,
  MODAL_SIZE,
  TEXTONLYREGEX,
  EMAILREGEX,
  TIMEREGEX,
  EVENT_TYPE,
  USER_ROLES,
  EVENT_TYPE_FR
} from "../../App.config";
import AttachmentDescription from "../../containers/Std/AttachmentDescription";
import ConfirmationModalPopup from "../../containers/Std/ConfirmationModalPopup";
import moment from "moment";

const AirComponent = (props) => {

  const initialState = {
    selectedFilterValue: {
      value: null,
      isDropdown: true,
      ref: useRef(),
      name: "filterValue",
      isSearchOption: true,
    },
    isSubmitOnce: { value: false },

    employerInformationId: {
      value: "",
    },
    employeeInformationId: {
      value: "",
    },
    airAccidentInformationId: {
      value: "",
    },
    lostTimeRTWInformationId: {
      value: "",
    },
    accidentDetailsId: {
      value: "",
    },
    companyName: {
      value: props.companyName,
      error: "",
      ref: useRef(),
      step: 1,
      positionCount: 1,
      label: "AIR-Employer-Information.form.label.text.CompanyName",
    },
    location: {
      value: [],
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 1,
      positionCount: 1,
      label: "AIR-Employer-Information.form.label.text.Location",
    },
    otherLocation: {
      value: "",
      error: "",
      ref: useRef(),
      step: 1,
      positionCount: 1,
      label: "AIR-Employer-Information.form.label.text.Location",
    },
    accFirm: {
      value: "Account Number",
      error: "",
      ref: useRef(),
      // validation: {
      //   required: true,
      // },
      step: 1,
      positionCount: 2,
      label: "AIR-Employer-Information.form.label.text.Account",
    },
    wcbNo: {
      value: "",
      error: "",
      ref: useRef(),
      // validation: {
      //   required: true,
      // },
      step: 1,
      positionCount: 2,
      label: "AIR-Employer-Information.form.label.text.WCBAccNo",
    },
    bussinessType: {
      value: "",
      error: "",
      ref: useRef(),
      step: 1,
      positionCount: 3,
      label: "AIR-Employer-Information.form.label.text.BusinessType",
    },
    classificationUnit: {
      value: "",
      error: "",
      ref: useRef(),
      step: 1,
      positionCount: 4,
      label: "AIR-Employer-Information.form.label.text.ClassificationUnit",
    },
    employeeFirstName: {
      value: "",
      error: "",
      shouldRequired: true,
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 2,
      positionCount: 1,
      label: "AIR-Employee-Information.form.label.text.EmployeeFirstName",
      isEditable: true
    },
    employeeLastName: {
      value: "",
      error: "",
      shouldRequired: true,
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 2,
      positionCount: 1,
      label: "AIR-Employee-Information.form.label.text.EmployeeLastName",
      isEditable: true
    },
    sin: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        minSINLength: 9,
        matchPattern: NUMBERREGEX,
      },
      label: "AIR-Employee-Information.form.label.text.SIN",
      positionCount: 2,
      step: 2,
    },
    dateOfBirth: {
      value: null,
      error: "",
      ref: useRef(),
      validation: {
      },
      label: "AIR-Employee-Information.form.label.text.DateOfBirth",
      positionCount: 3,
      step: 2,
      isEditable: true
    },
    dateOfHire: {
      value: null,
      error: "",
      ref: useRef(),
      validation: {
        isDate: true,
      },
      label: "AIR-Employee-Information.form.label.text.DateOfHire",
      positionCount: 4,
      step: 2,
      isEditable: true
    },
    employeeHealthCardNo: {
      value: "",
      error: "",
      ref: useRef(),
      label: "AIR-Employee-Information.form.label.text.HealthCardNo",
      positionCount: 5,
      step: 2,
    },
    employeeAddress1: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      label: "AIR-Employee-Information.form.label.text.EmployeeAddress",
      positionCount: 5,
      step: 2,
      isEditable: true
    },
    employeeAddress2: {
      value: "",
      error: "",
      ref: useRef(),
      label: "AIR-Employee-Information.form.label.text.EmployeeAddress2",
      positionCount: 5,
      step: 2,
      isEditable: true
    },
    province: {
      value: [],
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 2,
      positionCount: 6,
      label: "AIR-Employee-Information.form.label.text.Province",
      isEditable: true
    },
    country: {
      value: [],
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 2,
      positionCount: 6,
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Country",
      isEditable: true
    },
    city: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 2,
      positionCount: 7,
      label: "AIR-Employee-Information.form.label.text.City",
      isEditable: true
    },
    postalCode: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
        matchPattern: POST_CODE_REGEX,
        type: "Postal Code",
      },
      step: 2,
      positionCount: 8,
      label: "AIR-Employee-Information.form.label.text.PostalCode",
      isEditable: true
    },
    gender: {
      value: "Male",
      isEditable: true
    },
    employee: {
      value: "",
      error: "",
      ref: useRef(),
      step: 2,
      validation: {
        required: true
      },
      positionCount: 9,
      label: "AIR-Employee-Information.form.label.text.Employee",
      isEditable: true
    },
    employeeTelephone: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
      step: 2,
      positionCount: 10,
      label: "AIR-Employee-Information.form.label.text.EmployeeTel",
      isEditable: true
    },
    department: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        // required: true,
        //matchPattern: TEXTONLYREGEX
      },
      isEditable: true,
      step: 2,
      positionCount: 11,
      label: "AIR-Employee-Information.form.label.text.Department",
    },
    unionAffiliation: {
      value: "No",
    },
    employeeJobTitle: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
        // matchPattern: TEXTONLYREGEX
      },
      step: 2,
      positionCount: 10,
      label: "AIR-Employee-Information.form.label.text.JobTitle",
      isEditable: true
    },
    timeInPosition: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 2,
      positionCount: 10,
      label: "AIR-Employee-Information.form.label.text.TimeInPosition",
    },
    employeePrefLang: {
      value: "CFR",
      error: "",
      ref: useRef(),
      step: 2,
      positionCount: 10,
      label: "AIR-Employee-Information.form.label.text.EmployeePrefLang",
    },
    fileContactManagerName: {
      value: "",
      error: "",
      ref: useRef(),
      step: 2,
      isEditable: true,
    },

    managerName: {
      value: [],
      error: "",
      ref: useRef(),
      step: 2,
      isEditable: true
    },
    managerEmail: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
        matchPattern: EMAILREGEX,
        type: "Email"
      },
      step: 2,
      isEditable: true,
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Email",
    },
    managerTelephone: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
      step: 2,
      isEditable: true,
      label: "AIR-Employer-Information.form.label.text.TelephoneNumber",
    },
    typeCliam: {
      value: [],
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 3,
      positionCount: 1,
      label: "AIR-Accident-Information.form.label.text.TypeOfClaim",
    },
    dateOfAccident: {
      value: null,
      error: "",
      ref: useRef(),
      validation: {
        isDate: true,
      },
      label: "AIR-Accident-Information.form.label.text.DateOfAccident",
      positionCount: 2,
      step: 3,
    },
    timeOfAccident: {
      value: null,
      error: "",
      ref: useRef(),
      validation: {
        isTime: true,
        required: true,
        matchPattern: TIMEREGEX
      },
      positionCount: 3,
      step: 3,
    },
    timeOfAccidentRadio: {
      value: "AM",
    },
    dateOfReported: {
      value: null,
      error: "",
      ref: useRef(),
      validation: {
        isDate: true,
      },
      label: "AIR-Accident-Information.form.label.text.DateReported",
      positionCount: 4,
      step: 3,
    },
    timeOfReported: {
      value: null,
      error: "",
      ref: useRef(),
      validation: {
        isTime: true,
        required: true,
        matchPattern: TIMEREGEX
      },
      positionCount: 5,
      step: 3,
    },
    timeOfReportedRadio: {
      value: "AM",
    },
    timeOfEmployeeWorkBegan: {
      value: null,
      error: "",
      ref: useRef(),
      validation: {
        isTime: true,
        required: true,
        matchPattern: TIMEREGEX
      },
      positionCount: 5,
      step: 3,
    },
    timeOfEmployeeWorkBeganRadio: {
      value: "AM"
    },
    timeOfEmployeeWorkEnd: {
      value: null,
      error: "",
      ref: useRef(),
      validation: {
        isTime: true,
        // required:true,
        matchPattern: TIMEREGEX
      },
      positionCount: 5,
      step: 3,
    },
    timeOfEmployeeWorkEndRadio: {
      value: "AM"
    },
    dateOnsetSymptoms: {
      value: null,
      error: "",
      ref: useRef(),
      label: "AIR-Accident-Information.form.label.text.DateOnsetSymptoms",
      positionCount: 4,
      step: 3,
    },
    timeOnsetSymptoms: {
      value: null,
      error: "",
      ref: useRef(),
      validation: {
        // isTime: true,
        // required:true,
        matchPattern: TIMEREGEX
      },
      positionCount: 5,
      step: 3,
    },
    timeOnsetSymptomsRadio: {
      value: "AM",
    },
    doesWorkShift: {
      value: "No",
      isShowDependant: false,
    },
    workShift: {
      value: [],
      error: "",
      ref: useRef(),
      validation: {
        // required: true,
      },
      step: 3,
      positionCount: 6,
      label:
        "AIR-Accident-Information.form.label.text.DoestheEmployeeWorkShift",
    },
    doesWorkShiftExtra: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {},
      step: 3,
      positionCount: 7,
    },
    typeOfEmployment: {
      value: [],
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 3,
      positionCount: 8,
      label: "AIR-Accident-Information.form.label.text.TypeOfEmployement",
    },
    weekWDH: {
      value: [
        {
          shift:
            "Mon",
          name: "Mon",
          hours: "8.0",
        },
        {
          shift:
            "Tue",
          name: "Tue",
          hours: "8.0",
        },
        {
          shift:
            "Wed",
          name: "Wed",
          hours: "8.0",
        },
        {
          shift:
            "Thus",
          name: "Thus",
          hours: "8.0",
        },
        {
          shift:
            "Fri",
          name: "Fri",
          hours: "8.0",
        },
        {
          shift:
            "Sat",
          name: "Sat",
          hours: "0.0",
        },
        {
          shift:
            "Sun",
          name: "Sun",
          hours: "0.0",
        },
      ],
    },
    typeOfEmploymentExtra: {
      value: "",
      error: "",
      ref: useRef(),
    },
    payrate: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
        matchPattern: NUMBERREGEX,
        type: "Number",
      },
      step: 3,
      label: "AIR-Accident-Information.form.label.text.PayRate",
      positionCount: 10,
    },
    payPer: {
      value: "hour",
    },
    payOther: {
      value: "",
      error: "",
    },
    fourWeeksPriorEarningnfo: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      label: "AIR-Accident-Information.form.label.text.FourWeeksPriorInfo",
      positionCount: 10,
    },
    shiftPremium: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        matchPattern: NUMBERREGEX,
        type: "Number",
      },
      step: 3,
      positionCount: 10,
      label: "AIR-Accident-Information.form.label.text.ShiftPremium",
    },
    ThreeMonPriorEarningnfo: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      label: "AIR-Accident-Information.form.label.text.ThreeMonthsWeeksPriorInfo",
      positionCount: 10,
    },
    TwelMonthPriorEarningnfo: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      label: "AIR-Accident-Information.form.label.text.TwelWeeksPriorInfo",
      positionCount: 10,
    },
    addressOfRWL: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 3,
      label: "AIR-Accident-Information.form.label.text.AddressOfRWL",
      positionCount: 10,
    },
    overtimeToInjury: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      label: "AIR-Accident-Information.form.label.text.OvertimeToInjury",
      positionCount: 10,
    },
    overtimeToInjuryType: {
      value: "NA",
      error: "",
      ref: useRef(),
      step: 3,
      label: "AIR-Accident-Information.form.label.text.OvertimeToInjuryType",
      positionCount: 10,
    },

    accidentReported: {
      value: "Other",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 3,
      positionCount: 11,
      label: "AIR-Accident-Information.form.label.text.AccidentTitle",
    },
    accidentReportedManager: {
      value: [],
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 11,
      label: "AIR-Accident-Information.form.label.text.AccidentReported.Manager",
    },
    nameOfWhomReported: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      step: 3,
      positionCount: 11,
      label: "AIR-Accident-Information.form.label.text.Name",
      isEditable: true
    },
    positionOfWhomReported: {
      value: "",
      error: "",
      ref: useRef(),
      isEditable: true,
      validation: {
        required: true,
        matchPattern: TEXTONLYREGEX
      },
      step: 3,
      positionCount: 12,
      label: "AIR-Accident-Information.form.label.text.Position",
    },
    telephoneOfWhomReported: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
      step: 3,
      positionCount: 13,
      label: "AIR-Accident-Information.form.label.text.Telephone",
      isEditable: true
    },
    ExtOfWhomReported: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 13,
      label: "AIR-Accident-Information.form.label.text.Ext",
      isEditable: true
    },
    isFirstAidGiven: {
      value: "No",
    },
    dateOfFirstAidGiven: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
      },
      label: "AIR-Accident-Information.form.label.text.DateofFirstiAdGiven",
      positionCount: 15,
      step: 3,
    },
    firstAidAttendantName: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
      },
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.FirstAidAttendantName",
    },
    facilityTreatedName: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.FacilityTreatedName",
    },
    didHealthcareReceived: {
      value: "No",
    },
    healthcareName: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.byWhom",
    },
    healthcareAddress1: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.HealthcareAddress1",
    },
    healthcareAddress2: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.HealthcareAddress2",
    },
    healthcareCity: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.HealthcareAddress2",
    },
    healthcareProvince: {
      value: [],
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.HealthcareAddress2",
    },
    healthcareCountry: {
      value: [],
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.HealthcareAddress2",
    },
    healthcarePhone: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.HealthcarePhone",
    },
    facilityTreatedAddress1: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.FacilityTreatedAddress1",
    },
    facilityTreatedAddress2: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.FacilityTreatedAddress2",
    },
    facilityTreatedCity: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.FacilityTreatedCity",
    },
    facilityTreatedProvince: {
      value: [],
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.FacilityTreatedProvince",
    },
    facilityTreatedCountry: {
      value: [],
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.FacilityTreatedCountry",
    },
    facilityTreatedPhone: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.FacilityTreatedPhone",
    },
    treantedInHospital: {
      value: "Hospital",
    },
    hasCommiteeNotified: {
      value: "Yes",
    },
    providedRestrictions: {
      value: "Yes",
    },
    descRestrictions: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        // required: true
      },
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.DescRestrictions",
    },
    wereThereAnyWitness: {
      value: "No",
    },
    witnessName: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.WitnessName",
    },
    witnessPosition: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.WitnessPostion",
    },
    witnessWorkPhone: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.WitnessesWorkPhone",
    },
    witnessAdditionalInfo: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.WitnessesWorkPhone",
    },
    witnessName1: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.WitnessName",
    },
    witnessPosition1: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.WitnessPostion",
    },
    witnessWorkPhone1: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.WitnessesWorkPhone",
    },
    witnessName2: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.WitnessName",
    },
    witnessPosition2: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.WitnessPostion",
    },
    witnessWorkPhone2: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.WitnessesWorkPhone",
    },
    dateOfMedicalTretmenet: {
      value: "",
      error: "",
      ref: useRef(),
      label: "AIR-Accident-Information.form.label.text.Dateofmedicaltreatment",
      positionCount: 15,
      step: 3,
    },
    dateOfEmployerAboutMedicalTretmenet: {
      value: "",
      error: "",
      ref: useRef(),
      label:
        "AIR-Accident-Information.form.label.text.Dateemployeereceivedmedicalattention",
      positionCount: 16,
      step: 3,
    },
    // accidentQues1: {
    //   value: "No",
    // },
    // accidentQues1Comment: {
    //   value: "",
    //   error: "",
    //   ref: useRef(),
    //   validation: {
    //     // required: true,
    //   },
    //   step: 3,
    // },
    accidentQues2: {
      value: "No",
    },
    accidentQues2Comment: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        // required: true,
      },
      step: 3,
    },
    outsideCity: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.OutsideCity",
    },
    outsideProvince: {
      value: [],
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.OutsideProvice",
    },
    outsideCountry: {
      value: [],
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.OutsideCountry",
    },
    accidentQues3: {
      value: "No",
    },
    accidentQues3Comment: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        // required: true,
      },
    },
    responsibleName: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.ResponsibleName",
    },
    responsiblePhone: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
      label: "AIR-Accident-Information.form.label.text.ResponsiblePhone",
    },
    accidentQues4: {
      value: "No",
    },
    accidentQues4Comment: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        // required: true,
      },
      step: 3,
    },
    accidentQues5: {
      value: "No",
    },
    accidentQues5Comment: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        // required: true,
      },
      step: 3,
    },
    accidentQues6: {
      value: "No",
    },
    accidentQues6Comment: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        // required: true,
      },
      step: 3,
    },
    accidentQues7: {
      value: "No",
    },
    accidentQues7Comment: {
      value: "",
      error: "",

      ref: useRef(),
      validation: {
        // required: true,
      },
      step: 3,
    },
    accidentQues8: {
      value: "No",
    },
    accidentQues8Comment: {
      value: "",
      error: "",

      ref: useRef(),
      validation: {
        // required: true,
      },
      step: 3,
    },
    accidentQues9: {
      value: "No",
    },
    accidentQues9Comment: {
      value: "",
      error: "",
      ref: useRef(),

      validation: {
        // required: true,
      },
      step: 3,
    },
    accidentQues10: {
      value: "No",
    },
    accidentQues11: {
      value: "No",
    },
    specifyCompanyPremices: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      label: "AIR-Accident-Information.form.label.text.specifyCompanyPremises",
      positionCount: 10,
    },
    // rtwQuestion1: {
    //   value: "No",
    // },
    rtwQuestion2: {
      value: "No",
    },
    rtwQuestion3: {
      value: "No",
    },
    loseTimeFromWork: {
      value: "No",
    },
    lastDayWorkedDate: {
      value: "",
      error: "",
      //  validation:{
      //    isDate:true
      //  },
      ref: useRef(),
      label: "AIR-return-to-work-info.form.label.text.LastDayWorked",
      positionCount: 1,
      step: 5,
    },
    lastDayWorkTime: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        // required:true,
        isTime: true,
        matchPattern: TIMEREGEX
      },
      positionCount: 2,
      step: 5,
    },
    lastDayWorkTimeRadio: {
      value: "AM",
    },
    hasRTW: {
      value: "No",
    },
    typeRTW: {
      value: "Regular Work",
    },
    typeRTWExtra: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {},
      label: "AIR-return-to-work-info.form.label.text.TypeofWork",
      positionCount: 3,
      step: 4,
    },
    rtwDate: {
      value: null,
      error: "",
      ref: useRef(),
      // validation:{
      //   // isDate:true
      // },
      label: "AIR-return-to-work-info.form.label.text.DateReturnedWork",
      positionCount: 4,
      step: 5,
    },
    rtwTime: {
      value: "",
      error: "",
      validation: {
        isTime: true,
        // required:true,
        matchPattern: TIMEREGEX
      },
      ref: useRef(),
      positionCount: 5,
      step: 5,
    },
    rtwTimeRadio: {
      value: "AM",
    },
    rtwQuestion3Extra: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        // required: true,
      },
      label: "AIR-return-to-work-info.form.label.text.Que3",
      positionCount: 6,
      step: 4,
    },
    rtwQuestion4: {
      value: "No",
    },
    rtwQuestion5: {
      value: "No",
    },
    rtwQuestion5Extra: {
      value: null,
      error: "",
      ref: useRef(),
      label: "AIR-return-to-work-info.form.label.text.Que5",
      positionCount: 6,
      step: 4,
    },
    rtwQuestion6: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
    },
    rtwQuestion7: {
      value: "",
      error: "",
      ref: useRef(),
      step: 3,
      positionCount: 14,
    },
    whoIsResponsible: {
      value: "Other",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      label: "AIR-return-to-work-info.form.label.text.WhoIsResponsible",
      positionCount: 9,
      step: 4,
    },
    responsibleManager: {
      value: [],
      error: "",
      ref: useRef(),
      label: "AIR-return-to-work-info.form.label.text.WhoIsResponsible",
      positionCount: 9,
      step: 5,
    },
    responsibleRTWName: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        //required: true,
      },
      label: "AIR-return-to-work-info.form.label.text.Name",
      positionCount: 7,
      step: 5,
      isEditable: false,
    },
    responsibleRTWTelephone: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        //required: true,
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
      label: "AIR-return-to-work-info.form.label.text.Telephone",
      positionCount: 9,
      step: 5,
      isEditable: false,
    },
    sameAddresRTW: {
      value: false,
    },
    accidentDetailsQues1: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      label: "AIR-Accident-Details.form.label.text.InjuryLocation",
      positionCount: 1,
      step: 4,
    },
    accidentDetailsQues2: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      label: "AIR-Accident-Details.form.label.text.whatHappen",
      positionCount: 2,
      step: 4,
    },
    accidentDetailsQues3: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      label: "AIR-Accident-Details.form.label.text.WhatPart",
      positionCount: 3,
      step: 4,
    },
    accidentDetailsQues4: {
      value: "",
      error: "",
      ref: useRef(),
      label: "AIR-Accident-Details.form.label.text.Conditions",
      positionCount: 4,
      step: 5,
    },
    leftOrRightHandDominant: {
      value: "Left",
      error: "",
      ref: useRef(),
      label: "AIR-Accident-Details.form.label.text.LeftOrRightHandDominant",
      positionCount: 4,
      step: 5,
    },
    bodilyFluidHarmfulSubstanceExposure: {
      value: "",
      error: "",
      ref: useRef(),
      label: "AIR-Accident-Details.form.label.text.BodilyFluidHarmfulSubstanceExposure",
      positionCount: 4,
      step: 5,
    },
    relevantFacts: {
      value: "",
      error: "",
      ref: useRef(),
      label: "AIR-Accident-Details.form.label.text.RelevantFacts",
      positionCount: 4,
      step: 5,
    },
    // personInvolved: {
    //   value: false,
    // },
    equipmentInvolved: {
      value: false,
    },
    materialInvolved: {
      value: false,
    },
    environmentInvolved: {
      value: false,
    },
    processInvolved: {
      value: false,
    },
    // accidentDetailsQues5: {
    //   value: "",
    //   error: "",
    //   ref: useRef(),
    //   label: "AIR-Accident-Details.form.label.text.comments",
    //   positionCount: 5,
    //   step: 5,
    // },
    additionalNotesAdd: {
      value: "",
      error: "",
      ref: useRef(),
      positionCount: 5,
      step: 5,
    },

    accidentDetailsQues8: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        //required: true,
      },
      label: "AIR-Accident-Details.form.label.text.ResponsibleEquipment",
      positionCount: 7,
      step: 5,
    },
    eventType: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        //required: true,
      },
      label: "AIR-Accident-Details.form.label.text.EventType",
      positionCount: 7,
      step: 4,
    },
    identyfyDetailsForEquipmentMaterialInvolved: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      label: "AIR-Accident-Details.form.label.text.Identification",
      positionCount: 7,
      step: 4,
    },
    accidentDetailsQues9: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        //required: true,
      },
      label: "AIR-Accident-Details.form.label.text.SafetyEquipment",
      positionCount: 8,
      step: 5,
    },
    classificationOSHA: {
      value: "NA",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      label: "AIR-Accident-Details.form.label.text.OSHAClassification",
      positionCount: 8,
      step: 5,
    },
    declaration: {
      value: false,
      error: "",
      ref: useRef(),
      validation: {
        TermsAndCondition: true,
      },
      step: 5,
    },
    showManager: true,
    showManager1: true
  };

  const attachmentRef = useRef();
  const [state, setState] = useState(initialState);
  const [selectedCompanyDrp, setSelectedCompanyDrp] = useState(false);
  const dispatch = useDispatch();
  let stdAction = bindActionCreators(stdActions, dispatch);
  // const [isYourFirstVisit,setIsYourFirstVisit] = useState(true);
  const [urlLocation, setUrlLocation] = useState(props.urlLocation);

  const [selectedValueSave, setselectedValueSave] = useState(undefined);
  const [saveAppSave, setSaveAppSave] = useState(undefined);

  //set position value on language change
  useEffect(() => {
    if (state.accidentReported.value === "Manager") {
      setState((state) => {
        return {
          ...state,
          positionOfWhomReported: setValueToState("positionOfWhomReported", props.context.t('AIR-Accident-Information.form.label.text.AccidentReported.Manager')),
        }
      })
    }
  }, [props.i18nReducerLang, state.accidentReported.value])

  //Set initial step count after first render
  useEffect(() => {
    props.setMaxStep(5);
    props.setMinStep(1);
    props.setCurrentFormStep(1);
    onDiscard();
    props.resetAirApplicationUrl();
  }, []);

  // Get States by country
  useEffect(() => {
    if (state.country.value && state.country.value.length)
      props.getStates(utilities.extractFirstValueOfArray(state.country.value))

  }, [state.country.value])

  useEffect(() => {
    if (saveAppSave && !Array.isArray(saveAppSave) && saveAppSave.employeeInformation.employeeInformationId > 0) {
      setState((state) => {
        return {
          ...state,
          ['province']: setValueToStateForDrpId("province", saveAppSave.employeeInformation ? saveAppSave.employeeInformation.province : "", props.state, "provinceId", "provinceId"),
        };
      });

    }
    else {
      setState((state) => {
        return {
          ...state,
          ['province']: setValueToStateForDrpId("province", selectedValueSave ? selectedValueSave.provinceId : "", props.state, "provinceId", "provinceId"),
        };
      });

    }

  }, [props.state])

  useEffect(() => {
    fillLoggedCompanyName();
  }, [state.companyName.value])

  //Open pendingApplication model on page load
  useEffect(() => {
    callModal();
    // props.openSetModalAction(<ApplicationPending />, MODAL_SIZE.MODAL_SM);
    return function cleanup() {
      props.closeRemoveModal();
    };
  }, []);

  useEffect(() => {
    if (state.accidentReported.value == "Other" && (!state.nameOfWhomReported.value || !state.telephoneOfWhomReported.value)) {
      let updatedObj = state["accidentReportedManager"];
      updatedObj.value = [];
      updatedObj["validation"] = {
        required: true
      };

      setState((state) => {
        return {
          ...state,
          ['accidentReportedManager']: updatedObj,
          ['showManager']: true
        };
      });
    }
    else if (state.accidentReported.value == "Other" && state.nameOfWhomReported.value && state.telephoneOfWhomReported.value) {
      let updatedObj = state["accidentReportedManager"];
      updatedObj.value = [];
      updatedObj["validation"] = {};

      setState((state) => {
        return {
          ...state,
          ['accidentReportedManager']: updatedObj,
          ['showManager']: true
        };
      });
    }
  }, [state.accidentReported.value || state.nameOfWhomReported.value || state.telephoneOfWhomReported.value]);

  const callModal = () => {
    props.getAllPendingApplications(props.managersDetails.managerId);
  }

  useEffect(() => {
    if (state.nameOfWhomReported.value && state.telephoneOfWhomReported.value) {
      let updatedObj = state["accidentReportedManager"];
      updatedObj["validation"] = {}
      updatedObj["error"] = ""
      setState((state) => {
        return {
          ...state,
          ['accidentReportedManager']: updatedObj,
        };
      });
    }
    else {
      let updatedObj = state["accidentReportedManager"];
      updatedObj["validation"] = {
        required: true
      };
      setState((state) => {
        return {
          ...state,
          ['accidentReportedManager']: updatedObj,
        };
      });
    }
  }, [state.nameOfWhomReported.value && state.telephoneOfWhomReported.value])

  // To Open model if there is any pending applications
  useEffect(() => {
    let length = 0;
    props.allPendingApplications && props.allPendingApplications.map((pendingApplication) => {
      length = pendingApplication.applicationType == "AIR" ? length + 1 : length;


    })

    if (length > 0) {
      if (urlLocation && urlLocation.state && urlLocation.state.isRedirectFromNotification) {
        props.openSetModalAction(<ApplicationPending applicationType="AIR" />, MODAL_SIZE.MODAL_MD);
      }
    }


    props.resetAirReducer();
    props.setCurrentFormStep(1);
    setState((state) => {
      return {
        ...initialState
      };
    });
    fillLoggedCompanyName();
  }, [props.allPendingApplications.length])

  const fillLoggedCompanyName = () => {
    let companyState = state.companyName;
    companyState.value = props.managersDetails.companyName;
    setState((state) => {
      return {
        ...state,
        companyName: companyState
      };
    });
  }

  //Set CompanyName
  useEffect(() => {
    fillLoggedCompanyName();
  }, []);

  // clean on unmount
  useEffect(() => {
    return () => {
      onDiscard();
      props.resetAirApplicationUrl();
    };
  }, []);

  //Reset form to its initial state after form submit action
  useEffect(() => {
    if (props.isAdded) {
      props.resetIsAdded(false);
      props.setMaxStep(5);
      props.setMinStep(1);
      props.setCurrentFormStep(1);
      onDiscard();
      fillLoggedCompanyName();
      props.commonReducer && props.commonReducer.successMessage && goToHomeOrNot(props.commonReducer.successMessage);
      props.resetSuccessMessage("");
    }
  }, [props.isAdded]);

  const onDiscard = () => {
    setState((state) => {
      return { ...initialState };
    });
    props.resetContiuedPendingApplicationObj();
  };

  useEffect(() => {
    if (props.profileReducer && props.profileReducer.companyServices && !props.profileReducer.companyServices.hasDemographicFileFeature) {
      let fupdatedObj = state["fileContactManagerName"];
      fupdatedObj["error"] = "";
      fupdatedObj["validation"] = {
        required: true
      };
      setState((state) => {
        return {
          ...state,
          ['fileContactManagerName']: fupdatedObj,
        };
      });
    }
    else {
      let updatedObj = state["managerName"];
      updatedObj["validation"] = {
        required: true
      };
      setState((state) => {
        return {
          ...state,
          ['managerName']: updatedObj,
        };
      });
    }
  }, [props.stepCount == 2])

  // useEffect(() => {
  //   let managerName = state.managerName;
  //   let fileContactManager = state.fileContactManagerName;
  //   if(props.profileReducer && props.profileReducer.companyServices && !props.profileReducer.companyServices.hasDemographicFileFeature){
  //     delete managerName['validation']['required'];
  //   }
  //   else {
  //     delete fileContactManager['validation']['required'];
  //   }
  //   setState((state) => {
  //     return {
  //       ...state,
  //       "managerName": managerName,
  //       "fileContactManagerName": fileContactManager,
  //     };
  //   });
  // }, [props.profileReducer.companyServices])

  //Find ManagerDetails By ManagerId and Fill
  useEffect(() => onManagerChange(), [state.managerName.value])

  //Find Mangerdetails For Accident Reported User By ManagerId and Fill
  useEffect(() => onReportedManagerChange(), [state.accidentReportedManager.value])

  //Find Mangerdetails For Responsible User By ManagerId and Fill
  useEffect(() => onResponsableManagerChange(), [state.responsibleManager.value])

  // Execute function on set count change
  useEffect(() => onStepCountChange(), [props.stepCount]);

  // Execute function on work shift value change
  useEffect(() => onWorkShiftChange(), [state.workShift.value]);

  // Execute function on employment type change
  useEffect(() => onTypeOfEmpChange(), [state.typeOfEmployment.value]);

  // Execute function on RTW type change
  useEffect(() => onTypeOfRtwChange(), [state.typeRTW.value]);

  // Execute function on lose time from work value change
  useEffect(() => onLoseTimeFromWorkChange(), [state.loseTimeFromWork.value]);

  const goToHomeOrNot = (message) => {
    if (props.stepCount == props.maxStep) {
      swal({
        text: message,
        icon: "success",
        buttons: [{
          visible: true,
          text: props.context.t("Form.Submit.Close")
        }, {
          cancel: true,
          visible: true,
          text: props.context.t("Form.Submit.Download.Application")
        }
        ],
        dangerMode: false,
      })
        .then((isDownload) => {
          if (isDownload) {
            if (props.airFormPdfLink) {
              utilities.download(props.airFormPdfLink);
              history.push("/dashboard");
            }
            else {
              history.push("/dashboard");
            }
          } else {
            history.push("/dashboard");
          }
        });
    }
    else {
      swal(message)
        .then((value) => {
          // swal(`The returned value is: ${value}`);
          history.push("/dashboard");
        });
    }
  }

  const nextStep = () => {
    if (props.stepCount < props.maxStep) {
      props.setCurrentFormStep(props.stepCount + 1);
    }
  };

  const previousStep = () => {
    if (props.stepCount > props.minStep) {
      props.setCurrentFormStep(props.stepCount - 1);
      utilities.scrollToTop();
    }
  };

  const onManagerChange = () => {
    if (
      Array.isArray(state.managerName.value) &&
      state.managerName.value.length &&
      state.managerName.value != 0
    ) {
      let { primaryPhone, primaryEmail, primaryName } = props.supervisorList.find(
        (manager) =>
          manager.supervisorID_PK ===
          utilities.extractFirstValueOfArray(state.managerName.value)
      );
      let managerTelephone = utilities.convertIntoObject(
        normalizeInput(primaryPhone, null),
        state.managerTelephone
      );

      let managerEmail = utilities.convertIntoObject(
        primaryEmail,
        state.managerEmail
      );

      let fileContactManagerName = utilities.convertIntoObject(
        primaryName,
        state.fileContactManagerName
      );

      if (managerTelephone.value) {
        managerTelephone.isEditable = false;
      }
      else {
        managerTelephone.isEditable = true;
      }

      if (managerEmail.value) {
        managerEmail.isEditable = false;
      }
      else {
        managerEmail.isEditable = true;
      }
      if (fileContactManagerName.value) {
        fileContactManagerName.isEditable = false;
      }
      else {
        fileContactManagerName.isEditable = true;
      }


      setState((state) => {
        return {
          ...state,
          managerTelephone: managerTelephone && managerTelephone.value ? managerTelephone : state.managerTelephone,
          managerEmail: managerEmail && managerEmail.value ? managerEmail : state.managerEmail,
          fileContactManagerName: fileContactManagerName && fileContactManagerName.value ? fileContactManagerName : state.fileContactManagerName,
        };
      });
    }
    else {
      let managerTelephone = utilities.convertIntoObject(
        "",
        state.managerTelephone
      );

      let managerEmail = utilities.convertIntoObject(
        "",
        state.managerEmail
      );

      let fileContactManagerName = utilities.convertIntoObject(
        "",
        state.fileContactManagerName
      );

      managerTelephone.isEditable = true;
      managerEmail.isEditable = true;
      fileContactManagerName.isEditable = true;
      setState((state) => {
        return {
          ...state,
          managerTelephone: managerTelephone,
          managerEmail: managerEmail,
          fileContactManagerName: fileContactManagerName,
        };
      });
    }
  }

  const onReportedManagerChange = () => {
    if (
      Array.isArray(state.accidentReportedManager.value) &&
      state.accidentReportedManager.value.length
    ) {
      let { primaryPhone, primaryName } = props.supervisorList.find(
        (manager) =>
          manager.supervisorID_PK ===
          utilities.extractFirstValueOfArray(state.accidentReportedManager.value)
      );

      let telephoneOfWhomReported = utilities.convertIntoObject(
        normalizeInput(primaryPhone, ""),
        state.telephoneOfWhomReported
      )

      let nameOfWhomReported = utilities.convertIntoObject(
        primaryName,
        state.nameOfWhomReported
      )

      if (telephoneOfWhomReported.value) {
        telephoneOfWhomReported.isEditable = false;
      }
      else {
        telephoneOfWhomReported.isEditable = true;
      }

      if (nameOfWhomReported.value) {
        nameOfWhomReported.isEditable = false;
      }
      else {
        nameOfWhomReported.isEditable = false;
      }

      setState((state) => {
        return {
          ...state,
          telephoneOfWhomReported: telephoneOfWhomReported,
          nameOfWhomReported: nameOfWhomReported,
        };
      });
    }
    else {

      if (state.accidentReported.value != "Manager" && state.accidentReported.value != "Myself") {
        let telephoneOfWhomReported = utilities.convertIntoObject(
          "",
          state.telephoneOfWhomReported
        )

        let nameOfWhomReported = utilities.convertIntoObject(
          "",
          state.nameOfWhomReported
        )

        telephoneOfWhomReported.isEditable = true;
        nameOfWhomReported.isEditable = true;


        setState((state) => {
          return {
            ...state,
            telephoneOfWhomReported: telephoneOfWhomReported,
            nameOfWhomReported: nameOfWhomReported,
          };
        });
      }
      else if (state.showManager && (state.accidentReported.value == "Manager" || state.accidentReported.value == "Other")) {
        let telephoneOfWhomReported = utilities.convertIntoObject(
          "",
          state.telephoneOfWhomReported
        )

        let nameOfWhomReported = utilities.convertIntoObject(
          "",
          state.nameOfWhomReported
        )

        telephoneOfWhomReported.isEditable = true;
        nameOfWhomReported.isEditable = true;

        setState((state) => {
          return {
            ...state,
            telephoneOfWhomReported: telephoneOfWhomReported,
            nameOfWhomReported: nameOfWhomReported,
          };
        });
      }
    }
  }

  const onResponsableManagerChange = () => {
    if (
      Array.isArray(state.responsibleManager.value) &&
      state.responsibleManager.value.length
    ) {
      let { primaryPhone, primaryName } = props.supervisorList.find(
        (manager) =>
          manager.supervisorID_PK ===
          utilities.extractFirstValueOfArray(state.responsibleManager.value)
      );

      let responsibleRTWTelephone = utilities.convertIntoObject(
        normalizeInput(primaryPhone),
        state.responsibleRTWTelephone
      )

      let responsibleRTWName = utilities.convertIntoObject(
        primaryName,
        state.responsibleRTWName
      )

      if (responsibleRTWTelephone.value) {
        responsibleRTWTelephone.isEditable = false;
      }
      else {
        responsibleRTWTelephone.isEditable = true;
      }

      if (responsibleRTWName.value) {
        responsibleRTWName.isEditable = false;
      }
      else {
        responsibleRTWName.isEditable = true;
      }

      setState((state) => {
        return {
          ...state,
          responsibleRTWTelephone: responsibleRTWTelephone,
          responsibleRTWName: responsibleRTWName,
        };
      });
    }
    else {
      if (state.whoIsResponsible.value == "Manager") {
        let selectedValue = undefined;
        if (props.contiuedPendingApplicationObj && props.contiuedPendingApplicationObj.employeeInformation) {
          let selectedFilterValue = {
            label: props.contiuedPendingApplicationObj.employeeInformation.employeeLastName + " " + props.contiuedPendingApplicationObj.employeeInformation.employeeFirstName + " - " + props.contiuedPendingApplicationObj.employeeInformation.employeeNumber,
            value: props.contiuedPendingApplicationObj.employeeInformation.employeeNumber
          };
          Array.isArray(filterApplicationState.filterApplicationValues) &&
            filterApplicationState.filterApplicationValues.map((option, key) => {
              if (selectedFilterValue.value && selectedFilterValue.value === option.externalID) {
                selectedValue = option;
              }
            })
        }
        else {
          Array.isArray(filterApplicationState.filterApplicationValues) &&
            filterApplicationState.filterApplicationValues.map((option, key) => {
              if (state.selectedFilterValue.value && state.selectedFilterValue.value.value && state.selectedFilterValue.value.value) {
                if (state.selectedFilterValue.value.value && state.selectedFilterValue.value.value === option.externalID) {
                  selectedValue = option;
                }
              }

            })
        }

        if (selectedValue && selectedValue.managerName) {
          let flag = true;
          props.supervisorList.map((manager) => {
            if (manager.primaryName == selectedValue.managerName) {
              flag = false;
              setState((state) => {
                return {
                  ...state,
                  responsibleRTWName: setValueToState("responsibleRTWName", manager.primaryName),
                  responsibleRTWTelephone: setValueToState("responsibleRTWTelephone", normalizeInput(manager.primaryPhone, "")),
                  // positionOfWhomReported: setValueToState("positionOfWhomReported", "Manager"),
                  showManager1: false
                }
              })
              return;
            }
          })
          if (flag) {
            setState((state) => {
              return {
                ...state,
                // ["accidentReportedManager"]: changeRequired("accidentReportedManager", isRequired),
                ["showManager1"]: true
              };
            });
          }

        }
        else {
          setState((state) => {
            return {
              ...state,
              // ["accidentReportedManager"]: changeRequired("accidentReportedManager", isRequired),
              ["showManager1"]: true
            };
          });

          //this code is to remove unwanted data from state and to enable editable mode
          let responsibleNameStateValue = state.responsibleRTWName;
          let responsiblePhoneStateValue = state.responsibleRTWTelephone;
          responsibleNameStateValue.isEditable = true;
          responsiblePhoneStateValue.isEditable = true;
          setState((state) => {
            return {
              ...state,
              responsibleRTWName: responsibleNameStateValue,
              responsibleRTWTelephone: responsiblePhoneStateValue,
              // positionOfWhomReported: setValueToState("positionOfWhomReported", "Manager"),
              showManager1: true
            }
          })
        }
        // }

      }
      else {
        if (state.whoIsResponsible.value != "Myself") {
          let responsibleRTWTelephone1 = state.responsibleRTWTelephone;
          let responsibleRTWName1 = state.responsibleRTWName;

          responsibleRTWTelephone1.value = "";
          responsibleRTWName1.value = "";

          responsibleRTWTelephone1.isEditable = true;
          responsibleRTWName1.isEditable = true;

          setState((state) => {
            return {
              ...state,
              responsibleRTWTelephone: responsibleRTWTelephone1,
              responsibleRTWName: responsibleRTWName1,
            };
          });
        }
      }
    }
  }

  // Add/Remove validation dynamically
  const onLoseTimeFromWorkChange = () => {
    let updatedLastDayWorkedDate = state.lastDayWorkedDate;
    let updatedLastDayWorkTime = state.lastDayWorkTime;

    if (state.loseTimeFromWork.value === "Yes") {
      updatedLastDayWorkedDate.validation = {
        isDate: true,
      };
      updatedLastDayWorkedDate.error = "";

      // changeRequiredForTime();
      changeRequiredForTime("lastDayWorkTime", true)
      // updatedLastDayWorkTime.validation = {
      //   required: true,
      // };
      // updatedLastDayWorkTime.error = "";

      setState((state) => {
        return {
          ...state,
          lastDayWorkedDate: updatedLastDayWorkedDate,
          lastDayWorkTime: updatedLastDayWorkTime,
          isSubmitOnce: utilities.convertIntoObject(false),
        };
      });
    } else {
      if (updatedLastDayWorkedDate.validation) {
        delete updatedLastDayWorkedDate.validation;
        delete updatedLastDayWorkedDate.error;
        delete updatedLastDayWorkedDate.step;
        updatedLastDayWorkedDate.value = "";

        delete updatedLastDayWorkTime.validation;
        delete updatedLastDayWorkTime.error;
        delete updatedLastDayWorkTime.step;
        updatedLastDayWorkTime.value = null;

        setState((state) => {
          return {
            ...state,
            lastDayWorkedDate: updatedLastDayWorkedDate,
            lastDayWorkTime: updatedLastDayWorkTime,
          };
        });
      }
    }
  };

  const download = (filePath) => {
    const link = document.createElement("a");
    link.href = filePath;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileUpload = (event) => {
    let { files } = event.target;
    let formData = new FormData();
    if (files[0]) {
      formData.append("file", files[0]);
      formData.append("authToken", utilities.getTokenHeader().authToken);
      props.uploadFiles(formData, props.attachment, props);
    }

    event.target.value = ''
  };

  const addDescription = (index, attachmentDescription, attachment) =>
    props.openSetModalAction(
      <AttachmentDescription
        {...props}
        index={index}
        attachmentDescription={attachmentDescription}
        attachment={attachment}
      />,
      MODAL_SIZE.MODAL_SM
    );

  // Add/Remove validation dynamically
  const onTypeOfRtwChange = () => {
    let updatedRtwExtra = state.typeRTWExtra;

    if (state.typeRTW.value === "Other") {
      updatedRtwExtra.validation = {
        required: true,
      };
      updatedRtwExtra.step = 4;
      updatedRtwExtra.error = "";
      setState((state) => {
        return {
          ...state,
          typeRTWExtra: updatedRtwExtra,
          isSubmitOnce: utilities.convertIntoObject(false),
        };
      });
    } else {
      if (updatedRtwExtra.validation) {
        delete updatedRtwExtra.validation;
        delete updatedRtwExtra.error;
        delete updatedRtwExtra.step;
        updatedRtwExtra.value = "";
        setState((state) => {
          return {
            ...state,
            typeRTWExtra: updatedRtwExtra,
          };
        });
      }
    }
  };



  // Add/Remove validation dynamically
  const onTypeOfEmpChange = () => {
    let updatedEmploymentExtra = state.typeOfEmploymentExtra;

    if (
      utilities.extractFirstValueOfArray(state.typeOfEmployment.value) ===
      "Other"
    ) {
      updatedEmploymentExtra.validation = {
        required: true,
      };
      updatedEmploymentExtra.step = 3;
      updatedEmploymentExtra.error = "";
      setState((state) => {
        return {
          ...state,
          typeOfEmploymentExtra: updatedEmploymentExtra,
          isSubmitOnce: utilities.convertIntoObject(false),
        };
      });
    } else {
      if (updatedEmploymentExtra.validation) {
        delete updatedEmploymentExtra.validation;
        delete updatedEmploymentExtra.error;
        delete updatedEmploymentExtra.step;
        updatedEmploymentExtra.value = "";
        setState((state) => {
          return {
            ...state,
            typeOfEmploymentExtra: updatedEmploymentExtra,
          };
        });
      }
    }
  };

  // Add/Remove validation dynamically
  const onWorkShiftChange = () => {
    let updatedWorkShift = state.doesWorkShiftExtra;

    if (
      utilities.extractFirstValueOfArray(state.workShift.value) ===
      "Second Shift"
    ) {
      updatedWorkShift.validation = {
        required: true,
      };
      updatedWorkShift.step = 3;
      updatedWorkShift.error = "";
      setState((state) => {
        return {
          ...state,
          doesWorkShiftExtra: updatedWorkShift,
          isSubmitOnce: utilities.convertIntoObject(false),
        };
      });
    } else {
      if (updatedWorkShift.validation) {
        delete updatedWorkShift.validation;
        delete updatedWorkShift.error;
        delete updatedWorkShift.step;
        updatedWorkShift.value = "";
        setState((state) => {
          return {
            ...state,
            doesWorkShiftExtra: updatedWorkShift,
          };
        });
      }
    }
  };

  const getUpdatedObj = (stateName, stateValue) => {
    let updatedObj = state[stateName];
    updatedObj.value = stateValue;

    return updatedObj;
  }

  const removeValuesFromSpecify = (event) => {
    let { name, value, checked, type } = event.target;
    if (name == "accidentQues2") {
      if (value == "No") {
        setState((state) => {
          return {
            ...state,
            ["outsideCountry"]: getUpdatedObj("outsideCountry", []),
            ["outsideProvince"]: getUpdatedObj("outsideProvince", []),
            ["outsideCity"]: getUpdatedObj("outsideCity", "")
          };
        });
      }
    }
    else if (name == "accidentQues3") {
      if (value == "No") {
        setState((state) => {
          return {
            ...state,
            ["responsibleName"]: getUpdatedObj("responsibleName", ""),
            ["responsiblePhone"]: getUpdatedObj("responsiblePhone", ""),
          };
        });
      }
    }
    else if (name == "accidentQues4") {
      if (value == "No") {
        setState((state) => {
          return {
            ...state,
            ["accidentQues4Comment"]: getUpdatedObj("accidentQues4Comment", ""),
          };
        });
      }
    }
    else if (name == "accidentQues7") {
      if (value == "No") {
        setState((state) => {
          return {
            ...state,
            ["accidentQues7Comment"]: getUpdatedObj("accidentQues7Comment", ""),
          };
        });
      }

    }
    else if (name == "accidentQues9") {
      if (value == "No") {
        setState((state) => {
          return {
            ...state,
            ["accidentQues9Comment"]: getUpdatedObj("accidentQues9Comment", ""),
          };
        });
      }
    }
    else if (name == "accidentQues11") {
      if (value == "No") {
        setState((state) => {
          return {
            ...state,
            ["specifyCompanyPremices"]: getUpdatedObj("specifyCompanyPremices", ""),
          };
        });
      }
    }
  }

  const formatPostalCode = (postalCode) => {
    let postalcode = Array.from(postalCode);
    let formatedPostal = "";
    Array.isArray(postalcode) && postalcode.length && postalcode.map((partofpostal, i) => {
      if (i <= 6) {
        if (i == 3) {
          if (partofpostal == " ")
            formatedPostal = formatedPostal + partofpostal;
          else {
            formatedPostal = formatedPostal + " ";
            formatedPostal = formatedPostal + partofpostal;
          }
        }
        else
          formatedPostal = formatedPostal + partofpostal;

      }
    })
    return formatedPostal;
  }


  const handleChanges = (event) => {
    removeValuesFromSpecify(event);

    let { name, value, checked, type } = event.target;
    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) FormValidation();

    if (
      name === "managerTelephone"
    ) {
      setState((previousState) => {
        return {
          ...previousState,
          [name]: utilities.convertIntoObject(
            normalizeInput(updatedObj.value, previousState[name][value]),
            previousState[name]
          ),
        };
      });
    }

    else {
      setState((state) => {
        return {
          ...state,
          [name]: updatedObj,
        };
      });
    }

    changeRelatedFields(event);
  };

  const changeRelatedFields = (event) => {

    let { name, value, checked, type } = event.target;
    if (name == "sameAddresRTW") {
      let addressOfRWL = state.addressOfRWL;
      let incidentAddress = state.accidentDetailsQues1;
      if (value) {
        incidentAddress.value = addressOfRWL.value;
      }
      else {
        incidentAddress.value = "";
      }
      setState((state) => {
        return {
          ...state,
          ["accidentDetailsQues1"]: incidentAddress
        };
      });
    }
    if (name == "whoIsResponsible") {
      let responsibleRTWName = state.responsibleRTWName;
      let responsibleRTWTelephone = state.responsibleRTWTelephone;
      if (value == "Myself") {
        responsibleRTWName.value = props.managersDetails.firstName + ' ' + props.managersDetails.lastName;
        responsibleRTWTelephone.value = props.managersDetails.phone;
        responsibleRTWName.isEditable = false
        responsibleRTWTelephone.isEditable = false;

        setState((state) => {
          return {
            ...state,
            responsibleRTWName: responsibleRTWName,
            responsibleRTWTelephone: responsibleRTWTelephone,
          };
        });
      }
      else {
        responsibleRTWName.value = "";
        responsibleRTWTelephone.value = "";
        setState((state) => {
          return {
            ...state,
            responsibleRTWName: responsibleRTWName,
            responsibleRTWTelephone: responsibleRTWTelephone,
          };
        });
      }
    }
    if (name == "accidentReported") {
      let reportedName = state.nameOfWhomReported;
      let reportedPosition = state.positionOfWhomReported;
      let reportedTelephone = state.telephoneOfWhomReported;
      let reportedTelephoneExt = state.ExtOfWhomReported;
      if (value == "Myself") {
        reportedName.value = props.managersDetails.firstName + ' ' + props.managersDetails.lastName;
        reportedTelephone.value = props.managersDetails.phone;
        reportedPosition.value = props.profileReducer.managersDetails.roleId == USER_ROLES.LIMITED_CAL_MGR ? "Manager" : "";
        reportedName.isEditable = false;
        reportedTelephone.isEditable = false;
        reportedPosition.isEditable = props.profileReducer.managersDetails.roleId == USER_ROLES.LIMITED_CAL_MGR ? false : true;
      } else {
        reportedName.value = "";
        reportedName.isEditable = true;
        reportedPosition.value = "";
        reportedTelephone.value = "";
        reportedTelephone.isEditable = true;
        reportedTelephoneExt.value = "";
        reportedPosition.isEditable = true;
        reportedTelephoneExt.isEditable = true;
      }
      setState((state) => {
        return {
          ...state,
          ["nameOfWhomReported"]: reportedName,
          ["positionOfWhomReported"]: reportedPosition,
          ["telephoneOfWhomReported"]: reportedTelephone,
          ["ExtOfWhomReported"]: reportedTelephoneExt,
          ["showManager"]: false
        };
      });
    }
  }

  const getReportedManagerIntegerValue = (value) => {

    if (value == "Myself") {
      return 1;
    }
    else if (value == "Manager") {
      return 2;

    } else {
      return 3;
    }
  }
  const getReportedManagerString = (value) => {

    if (value == 1) {
      return "Myself";
    }
    else if (value == 2) {
      return "Manager";

    } else {
      return "Other";
    }
  }

  const onDateChange = (value, name) => {
    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((state) => {
      return { ...state, [name]: updatedObj };
    });
  };

  const normalizeInput = (value, previousValue) => {
    if (!value) return value;
    //remove any charater without alphnumeric
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length) {
      if (cvLength < 4) {
        return currentValue;
      } else if (cvLength < 7) {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(3)}`;
      } else {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(
          3,
          6
        )}-${currentValue.slice(6, 10)}`;
      }
    }
  };

  const normalizeInputForSIN = (value, previousValue, name) => {
    if (!value) return value;

    //remove any charater without alphnumeric
    let currentValue = value.replace(/-/g, "").replace(/ /g, "");

    const cvLength = currentValue.length;

    let part1 = "";
    let part2 = "";
    let part3 = "";

    if (!previousValue || value.length) {
      if (cvLength < 4) {
        return currentValue;
      }
      else if (cvLength < 7) {
        part1 = currentValue.slice(0, 3);
        part2 = currentValue.slice(3, 6)

      }
      else {
        part1 = currentValue.slice(0, 3);
        part2 = currentValue.slice(3, 6);
        part3 = currentValue.slice(6, 9);

      }

      if (cvLength <= 3) {
        return currentValue;
      } else if (cvLength <= 6) {
        return part1 + "-" + part2;
      } else {
        return part1 + "-" + part2 + "-" + part3;
      }
    }
  };

  const handlePhoneNumber = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((previousState) => {
      return {
        ...previousState,
        [name]: utilities.convertIntoObject(
          normalizeInput(updatedObj.value, previousState[name][value]),
          previousState[name]
        ),
      };
    });
  };

  const handleWeekShift = (event) => {
    let { name, value } = event.target;

    let updatedObj = state.weekWDH;
    updatedObj.value.forEach((day) => {
      if (day.name === name) {
        day.hours = value;
      }
    });

    setState((state) => {
      return {
        ...state,
        weekWDH: updatedObj,
      };
    });
  };

  const handleSIN = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((previousState) => {
      return {
        ...previousState,
        [name]: utilities.convertIntoObject(
          normalizeInputForSIN(updatedObj.value, previousState[name][value]),
          previousState[name]
        ),
      };
    });
  };

  const onTimeChange = (name, value) => {
    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((state) => {
      return { ...state, [name]: updatedObj };
    });
  };

  const onDropDownChangeRequiredOther = (name, value) => {
    if (name == "location") {
      let isRequired = value == "Other";
      setState((state) => {
        return {
          ...state,
          ["otherLocation"]: changeRequired("otherLocation", isRequired),
          ["otherLocation"]: clearValue("otherLocation"),
        };
      });
    }
  }

  const onDropDownChange = (event) => {
    let { name, value } = event;

    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    setState((state) => {
      return { ...state, [name]: updatedObj };
    });

    onDropDownChangeRequiredOther(name, value);

  };

  const FormValidationForSaveForLater = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        let propertywithnorequired = state[property];
        let validationobj = {}
        let compalsary = undefined;
        // propertywithnorequired.validation;
        // compalsary = propertywithnorequired.shouldRequired;
        Object.keys(propertywithnorequired.validation).forEach(function (key) {
          if (propertywithnorequired.shouldRequired != true) {
            if ((key != "required" && key != "isDate" && key != "isTime")) {
              validationobj[key] = propertywithnorequired.validation[key];
            }
          }
          else {
            validationobj = state[property].validation;
          }
        });
        propertywithnorequired.validation = validationobj;
        let validatedObj = validation(propertywithnorequired, props.context);
        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const FormValidation = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        let validatedObj = validation(state[property], props.context);

        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const resetFileInput = () => {
    attachmentRef.current.value = "";
  };

  const onAddManager = () => {
    props.openSetModalAction(
      <ManagerDetailModal
        {...props}
        jobID={state.employeeJobTitle.value}
        locationID={state.location.value}
      />,
      MODAL_SIZE.MODAL_SM
    );
  };

  const removeCompanyAttachmentsAction = (
    filePath,
    isDocs,
    index,
    allAttachments
  ) => {
    props.removeFiles(filePath, isDocs, index, allAttachments);
    resetFileInput();
    props.closeRemoveModal();
  };

  const removeFile = (filePath, isDocs, index, allAttachments) =>
    props.openSetModalAction(
      <ConfirmationModalPopup
        {...props}
        onYesClick={() =>
          removeCompanyAttachmentsAction(
            filePath,
            isDocs,
            index,
            allAttachments
          )
        }
      />,
      MODAL_SIZE.MODAL_SM
    );

  const isFormValid = (currentStepCount) => {
    let isValid = true;
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (
          state[property]?.error && state[property]?.error.length > 0 &&
          currentStepCount === state[property]?.step
        ) {
          isValid = false;
        }
      }
    }
    return isValid;
  };

  /// Validation showing in advance in another form steps
  const onStepCountChange = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (
          state[property]?.error && state[property]?.error.length > 0 &&
          state[property]?.step === props.stepCount
        ) {
          state[property].error = "";
          setState((previousState) => {
            return {
              ...previousState,
              [property]: state[property],
              isSubmitOnce: utilities.convertIntoObject(false),
            };
          });
        }
      }
    }
  };

  const getWorkingHrsByKey = (key) => {
    let hours = "0.0";
    Array.isArray(state.weekWDH.value) && state.weekWDH.value.length > 0 && state.weekWDH.value.map(({ ...day }) => {
      if (key === day.name) {
        if (!day.hours.toString().length) {
          hours = "0.0";
        }
        else {
          hours = day.hours
        }
      }
    });
    return hours;
  }

  const onAirSubmitAPI = (isPassed) => {
    console.log("state.timeOfEmployeeWorkEnd.value==>", state.timeOfEmployeeWorkEnd.value);

    let attachments = [...props.attachment];

    attachments = attachments.map((attachment) => {
      return {
        fileType: attachment.format,
        fileUploadPath: attachment.path,
        fileLength: attachment.size,
        uploadFileName: attachment.fileName,
        isDoc: attachment.isDoc,
        attachmentDescription: attachment.attachmentDescription,
        attachmentDataId: attachment.attachmentDataId,
      };
    });

    let convertValueForOptions = (value) => {
      if (value === "No") {
        return 0;
      }
      if (value === "Yes") {
        return 1;
      }
      if (value === "NA") {
        return 2;
      }
    };

    let airData = {

      employerInformation: {
        employerInformationId: state.employerInformationId.value,
        companyName: state.companyName.value,
        // location: utilities.extractFirstValueOfArray(state.location.value) === "Other" ?
        //   state.otherLocation.value : utilities.extractFirstValueOfArray(state.location.value),
        locationId: utilities.extractFirstValueOfArray(state.location.value),
        // account: state.account.value,
        account: "",
        accFirm: state.accFirm.value,
        wcbAccNo: state.wcbNo.value,
        businessType: state.bussinessType.value,
        classificationUnit: state.classificationUnit.value,
        contactName: "",
        position: "",
        telephoneNumber: "",
        createdByManagerId: props.managersDetails.managerId,
        isGeneratePDFinEnglish:
          props.i18nReducerLang === PREFERED_LANGUAGE_KEYS.EnglishUS
            ? true
            : false,
      },
      employeeInformation: {
        companyId: props.profileReducer && props.profileReducer.managersDetails && props.profileReducer.managersDetails.companyId,
        employeeInformationId: state.employeeInformationId.value,
        employeeFirstName: state.employeeFirstName.value,
        employeeLastName: state.employeeLastName.value,
        sin: state.sin.value,
        dateOfBirth: utilities.toAPIDateFormat(state.dateOfBirth.value),
        dateOfHire: utilities.toAPIDateFormat(state.dateOfHire.value),
        employeeHealthCardNo: state.employeeHealthCardNo.value,
        address1: state.employeeAddress1.value,
        address2: state.employeeAddress2.value,
        province: utilities.extractFirstValueOfArray(state.province.value),
        city: state.city.value,
        country: utilities.extractFirstValueOfArray(state.country.value),
        postalCode: state.postalCode.value,
        gender: state.gender.value,
        employeeNumber: state.employee.value,
        employeeTelNumber: state.employeeTelephone.value,
        department: state.department.value,
        occupationLengthOfServiceWhenInjured: state.timeInPosition.value,
        unionAffiliation:
          state.unionAffiliation.value === "Yes" ? true : false,
        employeeJobTitle: state.employeeJobTitle.value,
        employeeDateCommenced: "",
        employeePrefLang: state.employeePrefLang.value,
        isDemographicFileAvaliable: props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature,
        fileContactManagerName: state.fileContactManagerName.value,
        fileContactManagerId: utilities.extractFirstValueOfArray(state.managerName.value),
        fileContactManagerEmail: state.managerEmail.value,
        fileContactManagerPhone: state.managerTelephone.value,
        isCompleted: isPassed,
        stepsCompleted: props.stepCount
      },
      airAccidentInformation: {
        airAccidentInformationId: state.airAccidentInformationId.value,
        //working Hrs
        workScheduleMondayHrs: getWorkingHrsByKey("Mon"),
        workScheduleTuesdayHrs: getWorkingHrsByKey("Tue"),
        workScheduleWednesdayHrs: getWorkingHrsByKey("Wed"),
        workScheduleThursdayHrs: getWorkingHrsByKey("Thus"),
        workScheduleFridayHrs: getWorkingHrsByKey("Fri"),
        workScheduleSaturdayHrs: getWorkingHrsByKey("Sat"),
        workScheduleSundayHrs: getWorkingHrsByKey("Sun"),

        addressOfRegularWork: state.addressOfRWL.value,
        //regularWorkSchedule: utilities.extractFirstValueOfArray(state.regularWorkSchedule.value),
        typeOfClaim: utilities.extractFirstValueOfArray(
          state.typeCliam.value
        ),
        dateOfAccident: utilities.toAPIDateFormat(utilities.contactDateTime(
          state.dateOfAccident.value,
          moment(state.timeOfAccident.value + " " + state.timeOfAccidentRadio.value, ["h:mm A"])
        )),
        dateReported: utilities.toAPIDateFormat(utilities.contactDateTime(
          state.dateOfReported.value,
          moment(state.timeOfReported.value + " " + state.timeOfReportedRadio.value, ["h:mm A"])
        )),
        timeOfEmployeeWorkBegan: state.timeOfEmployeeWorkBegan.value ? utilities.toAPIDateFormat(utilities.contactDateTime(
          new Date(),
          moment(state.timeOfEmployeeWorkBegan.value + " " + state.timeOfEmployeeWorkBeganRadio.value, ["h:mm A"])
        )) : null,
        timeOfEmployeeWorkEnd: state.timeOfEmployeeWorkEnd.value ? utilities.toAPIDateFormat(utilities.contactDateTime(
          new Date(),
          moment(state.timeOfEmployeeWorkEnd.value + " " + state.timeOfEmployeeWorkEndRadio.value, ["h:mm A"])
        )) : null,
        dateOnsetSymptoms: utilities.toAPIDateFormat(utilities.contactDateTime(
          state.dateOnsetSymptoms.value,
          moment(state.timeOnsetSymptoms.value + " " + state.timeOnsetSymptomsRadio.value, ["h:mm A"])
        )),
        doesEmployeeWorkShifts:
          state.doesWorkShift.value === "Yes" ? true : false,
        shiftInformation: utilities.extractFirstValueOfArray(
          state.workShift.value
        ),
        doesEmployeeWorkShiftsDescription: state.doesWorkShiftExtra.value,
        typeOfEmployment: utilities.extractFirstValueOfArray(
          state.typeOfEmployment.value
        ),
        typeOfEmploymentOther: state.typeOfEmploymentExtra.value,
        payRate: Number(state.payrate.value),
        payPer: state.payPer.value,
        payOther: state.payOther.value,
        fourWeeksPriorEarningnfo: state.fourWeeksPriorEarningnfo.value,
        threeMonthsPriorEarningnfo: state.ThreeMonPriorEarningnfo.value,
        twelveMonthsPriorEarningnfo: state.TwelMonthPriorEarningnfo.value,
        overtimeToInjury: state.overtimeToInjury.value,
        overtimeToInjuryType: state.overtimeToInjuryType.value,
        shiftPremium: state.shiftPremium.value,
        name: state.nameOfWhomReported.value,
        position: state.positionOfWhomReported.value,
        telephone: state.telephoneOfWhomReported.value,
        extOfWhomReported: state.ExtOfWhomReported.value,
        accidentReportedSelection: getReportedManagerIntegerValue(state.accidentReported.value),
        isFirstAidGiven: state.isFirstAidGiven.value === "Yes" ? true : false,
        dateOfFirstAidGiven: utilities.toAPIDateFormat(state.dateOfFirstAidGiven.value),
        firstAidAttendantName: state.firstAidAttendantName.value,
        employeeReceiveHealthCare: convertValueForOptions(
          state.didHealthcareReceived.value
        ),
        doctorNameAddress: "",
        wereThereAnyWitness: state.wereThereAnyWitness.value === "Yes" ? true : false,
        witnessName: state.witnessName.value,
        witnessPosition: state.witnessPosition.value,
        witnessWorkPhone: state.witnessWorkPhone.value,
        witnessAdditionalInfo: state.witnessAdditionalInfo.value,
        didIncidentOccureInCompanyPremises: state.accidentQues11.value === "Yes" ? true : false,
        companyPremisesName: state.specifyCompanyPremices.value,
        healthcareName: state.healthcareName.value,
        healthcareAddress1: state.healthcareAddress1.value,
        healthcareAddress2: state.healthcareAddress2.value,
        healthcareCity: state.healthcareCity.value,
        healthcareProvince: utilities.extractFirstValueOfArray(state.healthcareProvince.value),
        healthcareCountry: utilities.extractFirstValueOfArray(state.healthcareCountry.value),
        healthcarePhone: state.healthcarePhone.value,
        facilityTreatedName: state.facilityTreatedName.value,
        facilityTreatedAddress1: state.facilityTreatedAddress1.value,
        facilityTreatedAddress2: state.facilityTreatedAddress2.value,
        facilityTreatedCity: state.facilityTreatedCity.value,
        facilityTreatedProvince: utilities.extractFirstValueOfArray(state.facilityTreatedProvince.value),
        facilityTreatedCountry: utilities.extractFirstValueOfArray(state.facilityTreatedCountry.value),
        facilityTreatedPhone: state.facilityTreatedPhone.value,
        treantedInHospital: state.treantedInHospital.value,
        hasCommiteeNotified: state.hasCommiteeNotified.value === "Yes" ? true : false,
        providedRestrictions: state.providedRestrictions.value === "Yes" ? true : false,
        descRestrictions: state.descRestrictions.value,
        dateOfMedicalTreatment: utilities.toAPIDateFormat(state.dateOfMedicalTretmenet.value),
        dateEmployerLearned: utilities.toAPIDateFormat(state.dateOfEmployerAboutMedicalTretmenet.value),
        // isEmployeeOwnerSpouseOfEmployer:
        //   state.accidentQues1.value === "Yes" ? true : false,
        // isEmployeeOwnerSpouseOfEmployerDescription:
        //   state.accidentQues1Comment.value,
        // didAccidentOccurOutsideYourResidentProvince:
        //   state.accidentQues2.value === "Yes" ? true : false,
        ousideIncidentCity: state.outsideCity.value,
        ousideIncidentProvince: utilities.extractFirstValueOfArray(state.outsideProvince.value),
        ousideIncidentCountry: utilities.extractFirstValueOfArray(state.outsideCountry.value),
        responsibleName: state.responsibleName.value,
        responsiblePhone: state.responsiblePhone.value,
        didAccidentOccurOutsideYourResidentProvinceDescription:
          state.accidentQues2Comment.value,
        wasAnyoneNotInYourEmploy:
          state.accidentQues3.value === "Yes" ? true : false,
        wasAnyoneNotInYourEmployDescription:
          state.accidentQues3Comment.value,
        doYouHaveReasonsToDoubtThat:
          state.accidentQues4.value === "Yes" ? true : false,
        doYouHaveReasonsToDoubtThatDescription:
          state.accidentQues4Comment.value,
        wasTheEmployeeInvolvedInNonworkRelated:
          state.accidentQues5.value === "Yes" ? true : false,
        wasTheEmployeeInvolvedInNonworkRelatedDescription:
          state.accidentQues5Comment.value,
        wasThereSeriousWillfulMisconductInvolved:
          state.accidentQues6.value === "Yes" ? true : false,
        wasThereSeriousWillfulMisconductInvolvedDescription:
          state.accidentQues6Comment.value,
        employeeHaveAsimilarPriorWork:
          state.accidentQues7.value === "Yes" ? true : false,
        employeeHaveAsimilarPriorWorkDescription:
          state.accidentQues7Comment.value,
        couldTheEmployeeHaveReturnedToWorkEarlier:
          state.accidentQues8.value === "Yes" ? true : false,
        couldTheEmployeeHaveReturnedToWorkEarlierDescription:
          state.accidentQues8Comment.value,
        isConcernClaimedAttached:
          state.accidentQues10.value === "Yes" ? true : false,
        werethereanythirdpartypersonsorequipmentinvolvedinincident:
          state.accidentQues9.value === "Yes" ? true : false,
        descEquipmentInvolvedIncident:
          state.accidentQues9Comment.value,
      },
      airLostTimeRTWInformation: {
        lostTimeRTWInformationId: state.lostTimeRTWInformationId.value,
        didEmployeeLoseTimeFromWorkDueToInjury:
          state.loseTimeFromWork.value === "Yes" ? true : false,
        lastDayWorkedDate: utilities.toAPIDateFormat(utilities.contactDateTime(
          state.lastDayWorkedDate.value,
          moment(state.lastDayWorkTime.value + " " + state.lastDayWorkTimeRadio.value, ["h:mm A"])
        )),
        hasEmployeeReturnedToWork:
          state.hasRTW.value === "Yes" ? true : false,
        typeOfWorkReturned: state.typeRTW.value,
        typeOfWorkReturnedOtherDescription: state.typeRTWExtra.value,
        dateRTW: utilities.toAPIDateFormat(utilities.contactDateTime(
          state.rtwDate.value,
          moment(state.rtwTime.value + " " + state.rtwTimeRadio.value, ["h:mm A"])
        )),
        // hasEmployeeBeenContactedRegardingRTW:
        //   state.rtwQuestion1.value === "Yes" ? true : false,
        haveYouBeenProvidedWorkRestrictionsInjury:
          state.rtwQuestion2.value === "Yes" ? true : false,
        isTheEmployeeWillingToReturnToModifiedWork:
          state.rtwQuestion3.value === "Yes" ? true : false,
        isTheEmployeeWillingToReturnToModifiedWorkDescription:
          state.rtwQuestion3Extra.value,
        hasModifiedWorkDiscussedOffered: convertValueForOptions(
          state.rtwQuestion4.value
        ),
        wereModifiedDutiesAccepted:
          state.rtwQuestion5.value === "Yes" ? true : false,
        haveWorkHoursChanged: state.rtwQuestion6.value,
        didPayRateChange: state.rtwQuestion7.value,
        dateStartedModifedDuties: utilities.toAPIDateFormat(state.rtwQuestion5Extra.value),
        whoIsResponsible: state.whoIsResponsible.value,
        responsibleForArrangingRTWName: state.responsibleRTWName.value,
        responsibleForArrangingRTWPosition: "",
        responsibleForArrangingRTWTelephone:
          state.responsibleRTWTelephone.value,
      },
      airAccidentDetails: {
        accidentDetailsId: state.accidentDetailsId.value,
        placeLocationInjuryOccur: state.accidentDetailsQues1.value,
        whatHappenedToCauseInjury: state.accidentDetailsQues2.value,
        partOfTheBodyInjured: state.accidentDetailsQues3.value,
        whatConditionsContributedToAccident:
          state.accidentDetailsQues4.value,
        //personInvolved: state.personInvolved.value,
        equipmentInvolved: state.equipmentInvolved.value,
        materialInvolved: state.materialInvolved.value,
        environmentInvolved: state.environmentInvolved.value,
        processInvolved: state.processInvolved.value,
        // commentsPreventionOfAsimilarAccident:
        //   state.accidentDetailsQues5.value,
        wereThereAnyWitnessesToAccident: "",
        // equipmentResponsibleForTheAccident:
        //   state.accidentDetailsQues8.value,
        wearingAppropriateSafetyEuipment: state.accidentDetailsQues9.value,
        classificationOSHA: state.classificationOSHA.value,
        leftOrRightHandDominant: state.leftOrRightHandDominant.value,
        bodilyFluidHarmfulSubstanceExposure: state.bodilyFluidHarmfulSubstanceExposure.value,
        relavantFacts: state.relevantFacts.value,
        eventType: state.eventType.value.value,
        identyfyDetailsForEquipmentMaterialInvolved: state.identyfyDetailsForEquipmentMaterialInvolved.value,
        additionalNotesAdd: state.additionalNotesAdd.value
      },
      airEmployeeAttachments: attachments,
    };
    props.addAirEmployeeStatement(airData);
  }

  const onSubmit = (isPassed = false, moveToNextPage = true) => {
    // setIsYourFirstVisit(false);
    if (urlLocation && urlLocation.state && urlLocation.state.isRedirectFromNotification) {
      let tempUrlLocation = urlLocation;
      tempUrlLocation.state.isRedirectFromNotification = false;
      setUrlLocation(tempUrlLocation);
    }
    setState((state) => {
      return {
        ...state,
        isSubmitOnce: utilities.convertIntoObject(true),
      };
    });

    if (props.stepCount !== props.maxStep) {
      document.querySelector("body").scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }

    if (!moveToNextPage && props.stepCount !== props.maxStep) {
      FormValidationForSaveForLater();
      if (isFormValid(props.stepCount)) {
        onAirSubmitAPI(isPassed);
      }
      else {
        let errorObject = [];

        for (const property in state) {
          if (state[property].step === props.stepCount && state[property].error)
            errorObject.push({
              name: property,
              label: state[property].label,
              error: state[property].error,
              positionCount: state[property].positionCount,
            });
        }
        errorObject.sort(function (a, b) {
          return a.positionCount - b.positionCount;
        });

        //Setting focus on first error field
        if (state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus) {
          if (state[errorObject[0].name].validation.isDate && state[errorObject[0].name].ref.current.input) // For Date
            state[errorObject[0].name].ref.current.input.focus();
          else
            state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus();
        } else {
          if (state[errorObject[0].name] && state[errorObject[0].name].validation && state[errorObject[0].name].validation.isDate && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.input) // For Date
            state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current.input.focus();
          else
            state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.setFocus();
        }
      }
    }
    else {
      FormValidation();

      if (isFormValid(props.stepCount)) {


        if (moveToNextPage) {
          nextStep();
        }
        else {
          onAirSubmitAPI(isPassed);
        }
      } else {

        //scroll to the top
        document.querySelector("body").scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });

        ///How to get First error in particular step
        let errorObject = [];

        for (const property in state) {
          if (state[property].step === props.stepCount && state[property].error)
            errorObject.push({
              name: property,
              label: state[property].label,
              error: state[property].error,
              positionCount: state[property].positionCount,
            });
        }
        errorObject.sort(function (a, b) {
          return a.positionCount - b.positionCount;
        });

        //Setting focus on first error field
        if (state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus) {
          if (state[errorObject[0].name].validation.isDate && state[errorObject[0].name].ref.current.input) // For Date
            state[errorObject[0].name].ref.current.input.focus();
          else
            state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus();
        } else {
          if (state[errorObject[0].name] && state[errorObject[0].name].validation && state[errorObject[0].name].validation.isDate && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.input) // For Date
            state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current.input.focus();
          else
            state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.setFocus();
        }
      }
    }

  };


  // Set value received from DB
  useEffect(() => {
    if (props.contiuedPendingApplicationObj && props.contiuedPendingApplicationObj.employeeInformation) {
      // setState((state) => {
      //   return {
      //     ...initialState
      //   };
      // });
      setAIRvalues();
    }
  }, [props.contiuedPendingApplicationObj])

  const setValueToStateForDrpId = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    let editableStatus = true;
    if (!valueToBeSet) {
      updatedObj.value = [];
    }
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      if (option[optionsValue] === valueToBeSet) {
        updatedObj.value = [valueToBeSet]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;

    return updatedObj;
  }

  const setValueToStateForDrpByIdValue = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    let editableStatus = true;
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      let optionVal = option[optionsKey] == "ENG" ? false : true;
      if (optionVal === valueToBeSet) {
        updatedObj.value = [option[optionsKey]]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;
    return updatedObj;
  }

  const setAIRvalues = () => {
    let currentState = state;
    const savedApp = props.contiuedPendingApplicationObj;
    setSaveAppSave(savedApp);
    currentState.employerInformationId.value = savedApp.employeeInformation.employerInformationId
    // if (props.location && Array.isArray(props.location) &&
    //   props.location.findIndex(x => x.locationName == savedApp.employerInformation.location) >= 0) {
    currentState.location.value = [savedApp.employerInformation.locationId];
    // }
    // else {
    //   currentState.location.value = ["Other"];
    //   currentState.otherLocation.value = savedApp.employerInformation.location;
    // }
    currentState.accFirm.value = savedApp.employerInformation.accFirm;
    currentState.wcbNo.value = savedApp.employerInformation.wcbAccNo;
    currentState.bussinessType.value = savedApp.employerInformation.businessType;
    currentState.classificationUnit.value = savedApp.employerInformation.classificationUnit;

    currentState.employeeInformationId.value = savedApp.employeeInformation.employeeInformationId
    // currentState.employeeFirstName.value = savedApp.employeeInformation.employeeFirstName
    setValueToState("employeeFirstName", savedApp.employeeInformation ? savedApp.employeeInformation.employeeFirstName : "")
    // currentState.employeeLastName.value = savedApp.employeeInformation.employeeLastName
    setValueToState("employeeLastName", savedApp.employeeInformation ? savedApp.employeeInformation.employeeLastName : "")
    currentState.sin.value = savedApp.employeeInformation.sin
    if (savedApp.employeeInformation && savedApp.employeeInformation.dateOfBirth) {
      // currentState.dateOfBirth.value = moment(savedApp.employeeInformation.dateOfBirth).toDate()
      setDateValueToState("dateOfBirth", savedApp.employeeInformation && savedApp.employeeInformation.dateOfBirth ? moment(savedApp.employeeInformation.dateOfBirth).toDate() : null)
    }
    if (savedApp.employeeInformation && savedApp.employeeInformation.dateOfHire)
      // currentState.dateOfHire.value = moment(savedApp.employeeInformation.dateOfHire).toDate()
      setDateValueToState("dateOfHire", savedApp.employeeInformation && savedApp.employeeInformation.dateOfHire ? moment(savedApp.employeeInformation.dateOfHire).toDate() : null)
    currentState.employeeHealthCardNo.value = savedApp.employeeInformation.employeeHealthCardNo
    // currentState.employeeAddress1.value = savedApp.employeeInformation.address1
    setValueToState("employeeAddress1", savedApp.employeeInformation ? savedApp.employeeInformation.address1 : "")
    // currentState.employeeAddress2.value = savedApp.employeeInformation.address2
    setValueToState("employeeAddress2", savedApp.employeeInformation ? savedApp.employeeInformation.address2 : "")
    // currentState.province.value = savedApp.employeeInformation.province ? [savedApp.employeeInformation.province] : currentState.province.value;
    //setValueToStateForDrpId("province", savedApp.employeeInformation ? savedApp.employeeInformation.province : "", props.state, "provinceId", "provinceId")
    //console.log("province = " + state.province.value);
    currentState.city.value = savedApp.employeeInformation.city
    currentState.country.value = savedApp.employeeInformation.country ? [savedApp.employeeInformation.country] : currentState.country.value;
    // currentState.postalCode.value = savedApp.employeeInformation.postalCode
    setValueToState("postalCode", savedApp.employeeInformation ? savedApp.employeeInformation.postalCode : "")
    // currentState.gender.value = savedApp.employeeInformation.gender
    setValueToState("gender", savedApp.employeeInformation ? savedApp.employeeInformation.gender : "")
    // currentState.employee.value = savedApp.employeeInformation.employeeNumber
    setValueToState("employee", savedApp.employeeInformation ? savedApp.employeeInformation.employeeNumber : "")
    // currentState.employeeTelephone.value = savedApp.employeeInformation.employeeTelNumber
    setValueToState("employeeTelephone", savedApp.employeeInformation ? normalizeInput(savedApp.employeeInformation.employeeTelNumber, "") : "")
    // currentState.department.value = savedApp.employeeInformation.department
    setValueToState("department", savedApp.employeeInformation ? savedApp.employeeInformation.department : "")
    currentState.timeInPosition.value = savedApp.employeeInformation.occupationLengthOfServiceWhenInjured ? savedApp.employeeInformation.occupationLengthOfServiceWhenInjured : currentState.timeInPosition.value
    currentState.unionAffiliation.value = savedApp.employeeInformation.unionAffiliation ? "Yes" : "No"
    // currentState.employeeJobTitle.value = savedApp.employeeInformation.employeeJobTitle
    setValueToState("employeeJobTitle", savedApp.employeeInformation ? savedApp.employeeInformation.employeeJobTitle : "")
    currentState.employeePrefLang.value = savedApp.employeeInformation.employeePrefLang
    // currentState.managerName.value = savedApp.employeeInformation && savedApp.employeeInformation.fileContactManagerId ? [savedApp.employeeInformation.fileContactManagerId] : currentState.managerName.value;
    if (props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature) {
      setValueToStateForDrpId("managerName", savedApp.employeeInformation ? savedApp.employeeInformation.fileContactManagerId : "", props.supervisorList, "supervisorID_PK", "supervisorID_PK")
    }
    else {
      currentState.fileContactManagerName.value = !props.profileReducer.companyServices.hasDemographicFileFeature ? savedApp.employeeInformation.fileContactManagerName.trim() : "";
    }

    currentState.managerEmail.value = savedApp.employeeInformation.fileContactManagerEmail
    currentState.managerTelephone.value = savedApp.employeeInformation.fileContactManagerPhone

    if (savedApp.airAccidentInformation && savedApp.airAccidentInformation.airAccidentInformationId) {
      currentState.airAccidentInformationId.value = savedApp.airAccidentInformation.airAccidentInformationId
      currentState.addressOfRWL.value = savedApp.airAccidentInformation.addressOfRegularWork
      currentState.typeCliam.value = savedApp.airAccidentInformation.typeOfClaim ? [savedApp.airAccidentInformation.typeOfClaim] : currentState.typeCliam.value;
      currentState.dateOfAccident.value = savedApp.airAccidentInformation.dateOfAccident ? moment(savedApp.airAccidentInformation.dateOfAccident).toDate() : null;
      // currentState.timeOfAccident.value = savedApp.airAccidentInformation.dateOfAccident ? moment(savedApp.airAccidentInformation.dateOfAccident) : currentState.timeOfAccident.value
      //  currentState.timeOfAccident.value = savedApp.airAccidentInformation.dateOfAccident ? (parseInt(savedApp.airAccidentInformation.dateOfAccident.toString().split("T")[1].split(":")[0])<12?savedApp.airAccidentInformation.dateOfAccident.toString().split("T")[1].split(":")[0]:(savedApp.airAccidentInformation.dateOfAccident.toString().split("T")[1].split(":")[0]-12)) + ":" + savedApp.airAccidentInformation.dateOfAccident.toString().split("T")[1].split(":")[1] : currentState.timeOfAccident.value
      currentState.timeOfAccident.value = savedApp.airAccidentInformation.dateOfAccident ? new Date('1970-01-01T' + savedApp.airAccidentInformation.dateOfAccident.toString().split("T")[1] + 'Z')
        .toLocaleTimeString('en-US',
          { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
        ).split(" ")[0] : currentState.timeOfAccident.value
      //  currentState.timeOfAccidentRadio.value = savedApp.airAccidentInformation.dateOfAccident ? parseInt(savedApp.airAccidentInformation.dateOfAccident.toString().split("T")[1].split(":")[0])<12?"AM":"PM":currentState.timeOfAccidentRadio.value
      currentState.timeOfAccidentRadio.value = savedApp.airAccidentInformation.dateOfAccident ? new Date('1970-01-01T' + savedApp.airAccidentInformation.dateOfAccident.toString().split("T")[1] + 'Z')
        .toLocaleTimeString('en-US',
          { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
        ).split(" ")[1] : currentState.timeOfAccidentRadio.value
      currentState.dateOfReported.value = savedApp.airAccidentInformation.dateReported ? moment(savedApp.airAccidentInformation.dateReported).toDate() : null;
      // currentState.timeOfReported.value = savedApp.airAccidentInformation.dateReported ? moment(savedApp.airAccidentInformation.dateReported) : currentState.timeOfReported.value
      // currentState.timeOfReported.value = savedApp.airAccidentInformation.dateReported ? (parseInt(savedApp.airAccidentInformation.dateReported.toString().split("T")[1].split(":")[0])<12?savedApp.airAccidentInformation.dateReported.toString().split("T")[1].split(":")[0]:(savedApp.airAccidentInformation.dateReported.toString().split("T")[1].split(":")[0]-12)) + ":" + savedApp.airAccidentInformation.dateReported.toString().split("T")[1].split(":")[1] : currentState.timeOfReported.value
      currentState.timeOfReported.value = savedApp.airAccidentInformation.dateReported ? new Date('1970-01-01T' + savedApp.airAccidentInformation.dateReported.toString().split("T")[1] + 'Z')
        .toLocaleTimeString('en-US',
          { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
        ).split(" ")[0] : currentState.timeOfReported.value

      // currentState.timeOfReportedRadio.value = savedApp.airAccidentInformation.dateReported ? parseInt(savedApp.airAccidentInformation.dateReported.toString().split("T")[1].split(":")[0])<12?"AM":"PM":currentState.timeOfReportedRadio.value
      currentState.timeOfReportedRadio.value = savedApp.airAccidentInformation.dateReported ? new Date('1970-01-01T' + savedApp.airAccidentInformation.dateReported.toString().split("T")[1] + 'Z')
        .toLocaleTimeString('en-US',
          { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
        ).split(" ")[1] : currentState.timeOfReportedRadio.value

      // currentState.timeOfEmployeeWorkBegan.value = savedApp.airAccidentInformation.timeOfEmployeeWorkBegan ? moment(savedApp.airAccidentInformation.timeOfEmployeeWorkBegan) : currentState.timeOfEmployeeWorkBegan.value
      // currentState.timeOfEmployeeWorkBegan.value = savedApp.airAccidentInformation.timeOfEmployeeWorkBegan ? (parseInt(savedApp.airAccidentInformation.timeOfEmployeeWorkBegan.toString().split("T")[1].split(":")[0])<12?savedApp.airAccidentInformation.timeOfEmployeeWorkBegan.toString().split("T")[1].split(":")[0]:(savedApp.airAccidentInformation.timeOfEmployeeWorkBegan.toString().split("T")[1].split(":")[0]-12)) + ":" + savedApp.airAccidentInformation.timeOfEmployeeWorkBegan.toString().split("T")[1].split(":")[1] : currentState.timeOfEmployeeWorkBegan.value
      currentState.timeOfEmployeeWorkBegan.value = savedApp.airAccidentInformation.timeOfEmployeeWorkBegan ? new Date('1970-01-01T' + savedApp.airAccidentInformation.timeOfEmployeeWorkBegan.toString().split("T")[1] + 'Z')
        .toLocaleTimeString('en-US',
          { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
        ).split(" ")[0] : currentState.timeOfEmployeeWorkBegan.value

      // currentState.timeOfEmployeeWorkBeganRadio.value = savedApp.airAccidentInformation.timeOfEmployeeWorkBegan ? parseInt(savedApp.airAccidentInformation.timeOfEmployeeWorkBegan.toString().split("T")[1].split(":")[0])<12?"AM":"PM":currentState.timeOfEmployeeWorkBeganRadio.value
      currentState.timeOfEmployeeWorkBeganRadio.value = savedApp.airAccidentInformation.timeOfEmployeeWorkBegan ? new Date('1970-01-01T' + savedApp.airAccidentInformation.timeOfEmployeeWorkBegan.toString().split("T")[1] + 'Z')
        .toLocaleTimeString('en-US',
          { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
        ).split(" ")[1] : currentState.timeOfEmployeeWorkBeganRadio.value

      // currentState.timeOfEmployeeWorkEnd.value = savedApp.airAccidentInformation.timeOfEmployeeWorkEnd ? moment(savedApp.airAccidentInformation.timeOfEmployeeWorkEnd) : currentState.timeOfEmployeeWorkEnd.value
      // currentState.timeOfEmployeeWorkEnd.value = savedApp.airAccidentInformation.timeOfEmployeeWorkEnd ? (parseInt(savedApp.airAccidentInformation.timeOfEmployeeWorkEnd.toString().split("T")[1].split(":")[0])<12?savedApp.airAccidentInformation.timeOfEmployeeWorkEnd.toString().split("T")[1].split(":")[0]:(savedApp.airAccidentInformation.timeOfEmployeeWorkEnd.toString().split("T")[1].split(":")[0]-12)) + ":" + savedApp.airAccidentInformation.timeOfEmployeeWorkEnd.toString().split("T")[1].split(":")[1] : currentState.timeOfEmployeeWorkEnd.value
      currentState.timeOfEmployeeWorkEnd.value = savedApp.airAccidentInformation.timeOfEmployeeWorkEnd ? new Date('1970-01-01T' + savedApp.airAccidentInformation.timeOfEmployeeWorkEnd.toString().split("T")[1] + 'Z')
        .toLocaleTimeString('en-US',
          { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
        ).split(" ")[0] : currentState.timeOfEmployeeWorkEnd.value

      // currentState.timeOfEmployeeWorkEndRadio.value = savedApp.airAccidentInformation.timeOfEmployeeWorkEnd ? parseInt(savedApp.airAccidentInformation.timeOfEmployeeWorkEnd.toString().split("T")[1].split(":")[0])<12?"AM":"PM":currentState.timeOfEmployeeWorkEndRadio.value;
      currentState.timeOfEmployeeWorkEndRadio.value = savedApp.airAccidentInformation.timeOfEmployeeWorkEnd ? new Date('1970-01-01T' + savedApp.airAccidentInformation.timeOfEmployeeWorkEnd.toString().split("T")[1] + 'Z')
        .toLocaleTimeString('en-US',
          { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
        ).split(" ")[1] : currentState.timeOfEmployeeWorkEndRadio.value;

      if (savedApp.airAccidentInformation && savedApp.airAccidentInformation.dateOnsetSymptoms) {
        currentState.dateOnsetSymptoms.value = moment(savedApp.airAccidentInformation.dateOnsetSymptoms).toDate()
        // currentState.timeOnsetSymptoms.value = savedApp.airAccidentInformation.dateOnsetSymptoms ? moment(savedApp.airAccidentInformation.dateOnsetSymptoms) : currentState.timeOnsetSymptoms.value;
        // currentState.timeOnsetSymptoms.value = savedApp.airAccidentInformation.dateOnsetSymptoms ? (parseInt(savedApp.airAccidentInformation.dateOnsetSymptoms.toString().split("T")[1].split(":")[0])<12?savedApp.airAccidentInformation.dateOnsetSymptoms.toString().split("T")[1].split(":")[0]:(savedApp.airAccidentInformation.dateOnsetSymptoms.toString().split("T")[1].split(":")[0]-12)) + ":" + savedApp.airAccidentInformation.dateOnsetSymptoms.toString().split("T")[1].split(":")[1] : currentState.timeOnsetSymptoms.value;
        currentState.timeOnsetSymptoms.value = savedApp.airAccidentInformation.dateOnsetSymptoms ? new Date('1970-01-01T' + savedApp.airAccidentInformation.dateOnsetSymptoms.toString().split("T")[1] + 'Z')
          .toLocaleTimeString('en-US',
            { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
          ).split(" ")[0] : currentState.timeOnsetSymptoms.value;

        // currentState.timeOnsetSymptomsRadio.value = savedApp.airAccidentInformation.dateOnsetSymptoms ? parseInt(savedApp.airAccidentInformation.dateOnsetSymptoms.toString().split("T")[1].split(":")[0])<12?"AM":"PM":currentState.timeOnsetSymptomsRadio.value
        currentState.timeOnsetSymptomsRadio.value = savedApp.airAccidentInformation.dateOnsetSymptoms ? new Date('1970-01-01T' + savedApp.airAccidentInformation.dateOnsetSymptoms.toString().split("T")[1] + 'Z')
          .toLocaleTimeString('en-US',
            { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
          ).split(" ")[1] : currentState.timeOnsetSymptomsRadio.value
      }
      currentState.doesWorkShift.value = savedApp.airAccidentInformation.doesEmployeeWorkShifts ? "Yes" : "No"
      currentState.workShift.value = savedApp.airAccidentInformation.shiftInformation ? [savedApp.airAccidentInformation.shiftInformation] : currentState.workShift.value;
      currentState.doesWorkShiftExtra.value = savedApp.airAccidentInformation.doesEmployeeWorkShiftsDescription
      currentState.typeOfEmployment.value = savedApp.airAccidentInformation.typeOfEmployment ? [savedApp.airAccidentInformation.typeOfEmployment] : currentState.typeOfEmployment.value;
      currentState.typeOfEmploymentExtra.value = savedApp.airAccidentInformation.typeOfEmploymentOther
      currentState.payrate.value = Number(savedApp.airAccidentInformation.payRate).toString();
      currentState.payPer.value = savedApp.airAccidentInformation.payPer
      currentState.payOther.value = savedApp.airAccidentInformation.payOther
      currentState.fourWeeksPriorEarningnfo.value = savedApp.airAccidentInformation.fourWeeksPriorEarningnfo
      currentState.ThreeMonPriorEarningnfo.value = savedApp.airAccidentInformation.threeMonthsPriorEarningnfo
      currentState.TwelMonthPriorEarningnfo.value = savedApp.airAccidentInformation.twelveMonthsPriorEarningnfo
      currentState.overtimeToInjury.value = savedApp.airAccidentInformation.overtimeToInjury
      currentState.overtimeToInjuryType.value = savedApp.airAccidentInformation.overtimeToInjuryType
      currentState.shiftPremium.value = savedApp.airAccidentInformation.shiftPremium
      currentState.nameOfWhomReported.value = savedApp.airAccidentInformation.name
      currentState.positionOfWhomReported.value = savedApp.airAccidentInformation.position
      currentState.telephoneOfWhomReported.value = savedApp.airAccidentInformation.telephone
      if (currentState.nameOfWhomReported.value && currentState.telephoneOfWhomReported.value) {
        let updatedObj = state["accidentReportedManager"];
        updatedObj["validation"] = {}
        updatedObj["error"] = ""
        setState((state) => {
          return {
            ...state,
            ['accidentReportedManager']: updatedObj,
            ['showManager']: true
          };
        });
      }
      else {
        let updatedObj = state["accidentReportedManager"];
        updatedObj["validation"] = {
          required: true
        };
        setState((state) => {
          return {
            ...state,
            ['accidentReportedManager']: updatedObj,
            ['showManager']: true
          };
        });
      }
      currentState.ExtOfWhomReported.value = savedApp.airAccidentInformation.extOfWhomReported
      currentState.accidentReported.value = getReportedManagerString(savedApp.airAccidentInformation.accidentReportedSelection)
      currentState.isFirstAidGiven.value = savedApp.airAccidentInformation.isFirstAidGiven ? "Yes" : "No"
      if (savedApp.airAccidentInformation && savedApp.airAccidentInformation.dateOfFirstAidGiven)
        currentState.dateOfFirstAidGiven.value = moment(savedApp.airAccidentInformation.dateOfFirstAidGiven).toDate()
      currentState.firstAidAttendantName.value = savedApp.airAccidentInformation.firstAidAttendantName
      currentState.didHealthcareReceived.value = savedApp.airAccidentInformation.employeeReceiveHealthCare ? "Yes" : "No"
      currentState.wereThereAnyWitness.value = savedApp.airAccidentInformation.wereThereAnyWitness ? "Yes" : "No"
      currentState.witnessName.value = savedApp.airAccidentInformation.witnessName
      currentState.witnessPosition.value = savedApp.airAccidentInformation.witnessPosition
      currentState.witnessWorkPhone.value = savedApp.airAccidentInformation.witnessWorkPhone
      currentState.witnessAdditionalInfo.value = savedApp.airAccidentInformation.witnessAdditionalInfo
      currentState.accidentQues11.value = savedApp.airAccidentInformation.didIncidentOccureInCompanyPremises ? "Yes" : "No"
      currentState.specifyCompanyPremices.value = savedApp.airAccidentInformation.companyPremisesName
      currentState.healthcareName.value = savedApp.airAccidentInformation.healthcareName
      currentState.healthcareAddress1.value = savedApp.airAccidentInformation.healthcareAddress1
      currentState.healthcareAddress2.value = savedApp.airAccidentInformation.healthcareAddress2
      currentState.healthcareCity.value = savedApp.airAccidentInformation.healthcareCity
      currentState.healthcareProvince.value = savedApp.airAccidentInformation.healthcareProvince ? [savedApp.airAccidentInformation.healthcareProvince] : currentState.healthcareProvince.value
      currentState.healthcareCountry.value = savedApp.airAccidentInformation.healthcareCountry ? [savedApp.airAccidentInformation.healthcareCountry] : currentState.healthcareCountry.value;
      currentState.healthcarePhone.value = savedApp.airAccidentInformation.healthcarePhone
      currentState.facilityTreatedName.value = savedApp.airAccidentInformation.facilityTreatedName
      currentState.facilityTreatedAddress1.value = savedApp.airAccidentInformation.facilityTreatedAddress1
      currentState.facilityTreatedAddress2.value = savedApp.airAccidentInformation.facilityTreatedAddress2
      currentState.facilityTreatedCity.value = savedApp.airAccidentInformation.facilityTreatedCity
      currentState.facilityTreatedProvince.value = savedApp.airAccidentInformation.facilityTreatedProvince ? [savedApp.airAccidentInformation.facilityTreatedProvince] : currentState.facilityTreatedProvince.value
      currentState.facilityTreatedCountry.value = savedApp.airAccidentInformation.facilityTreatedCountry ? [savedApp.airAccidentInformation.facilityTreatedCountry] : currentState.facilityTreatedCountry.value
      currentState.facilityTreatedPhone.value = savedApp.airAccidentInformation.facilityTreatedPhone
      currentState.treantedInHospital.value = savedApp.airAccidentInformation.treantedInHospital
      currentState.hasCommiteeNotified.value = savedApp.airAccidentInformation.hasCommiteeNotified ? "Yes" : "No"
      currentState.providedRestrictions.value = savedApp.airAccidentInformation.providedRestrictions ? "Yes" : "No"
      currentState.descRestrictions.value = savedApp.airAccidentInformation.descRestrictions
      if (savedApp.airAccidentInformation && savedApp.airAccidentInformation.dateOfMedicalTreatment)
        currentState.dateOfMedicalTretmenet.value = moment(savedApp.airAccidentInformation.dateOfMedicalTreatment).toDate()
      if (savedApp.airAccidentInformation && savedApp.airAccidentInformation.dateEmployerLearned)
        currentState.dateOfEmployerAboutMedicalTretmenet.value = moment(savedApp.airAccidentInformation.dateEmployerLearned).toDate()
      // currentState.accidentQues1.value = savedApp.airAccidentInformation.isEmployeeOwnerSpouseOfEmployer ? "Yes" : "No"
      // currentState.accidentQues1Comment.value = savedApp.airAccidentInformation.isEmployeeOwnerSpouseOfEmployerDescription
      //currentState.accidentQues2.value = savedApp.airAccidentInformation.didAccidentOccurOutsideYourResidentProvince ? "Yes" : "No"
      currentState.outsideCity.value = savedApp.airAccidentInformation.ousideIncidentCity
      currentState.outsideProvince.value = savedApp.airAccidentInformation.ousideIncidentProvince ? [savedApp.airAccidentInformation.ousideIncidentProvince] : currentState.outsideProvince.value;
      currentState.outsideCountry.value = savedApp.airAccidentInformation.ousideIncidentCountry ? [savedApp.airAccidentInformation.ousideIncidentCountry] : currentState.outsideCountry.value
      currentState.responsibleName.value = savedApp.airAccidentInformation.responsibleName
      currentState.responsiblePhone.value = savedApp.airAccidentInformation.responsiblePhone
      currentState.accidentQues2Comment.value = savedApp.airAccidentInformation.didAccidentOccurOutsideYourResidentProvinceDescription
      currentState.accidentQues3.value = savedApp.airAccidentInformation.wasAnyoneNotInYourEmploy ? "Yes" : "No"
      currentState.accidentQues3Comment.value = savedApp.airAccidentInformation.wasAnyoneNotInYourEmployDescription
      currentState.accidentQues4.value = savedApp.airAccidentInformation.doYouHaveReasonsToDoubtThat ? "Yes" : "No"
      currentState.accidentQues4Comment.value = savedApp.airAccidentInformation.doYouHaveReasonsToDoubtThatDescription
      currentState.accidentQues5.value = savedApp.airAccidentInformation.wasTheEmployeeInvolvedInNonworkRelated ? "Yes" : "No"
      currentState.accidentQues5Comment.value = savedApp.airAccidentInformation.wasTheEmployeeInvolvedInNonworkRelatedDescription
      currentState.accidentQues6.value = savedApp.airAccidentInformation.wasThereSeriousWillfulMisconductInvolved ? "Yes" : "No"
      currentState.accidentQues6Comment.value = savedApp.airAccidentInformation.wasThereSeriousWillfulMisconductInvolvedDescription
      currentState.accidentQues7.value = savedApp.airAccidentInformation.employeeHaveAsimilarPriorWork ? "Yes" : "No"
      currentState.accidentQues7Comment.value = savedApp.airAccidentInformation.employeeHaveAsimilarPriorWorkDescription
      currentState.accidentQues8.value = savedApp.airAccidentInformation.couldTheEmployeeHaveReturnedToWorkEarlier ? "Yes" : "No"
      currentState.accidentQues8Comment.value = savedApp.airAccidentInformation.couldTheEmployeeHaveReturnedToWorkEarlierDescription
      currentState.accidentQues9.value = savedApp.airAccidentInformation.werethereanythirdpartypersonsorequipmentinvolvedinincident ? "Yes" : "No"
      currentState.accidentQues10.value = savedApp.airAccidentInformation.isConcernClaimedAttached ? "Yes" : "No"
      currentState.accidentQues9Comment.value = savedApp.airAccidentInformation.descEquipmentInvolvedIncident || "";
      currentState.weekWDH.value[0].hours = savedApp.airAccidentInformation.workScheduleMondayHrs
      currentState.weekWDH.value[1].hours = savedApp.airAccidentInformation.workScheduleTuesdayHrs
      currentState.weekWDH.value[2].hours = savedApp.airAccidentInformation.workScheduleWednesdayHrs
      currentState.weekWDH.value[3].hours = savedApp.airAccidentInformation.workScheduleThursdayHrs
      currentState.weekWDH.value[4].hours = savedApp.airAccidentInformation.workScheduleFridayHrs
      currentState.weekWDH.value[5].hours = savedApp.airAccidentInformation.workScheduleSaturdayHrs
      currentState.weekWDH.value[6].hours = savedApp.airAccidentInformation.workScheduleSundayHrs

    }
    if (savedApp.airLostTimeRTWInformation && savedApp.airLostTimeRTWInformation.lostTimeRTWInformationId) {
      currentState.lostTimeRTWInformationId.value = savedApp.airLostTimeRTWInformation.lostTimeRTWInformationId
      currentState.lostTimeRTWInformationId.value = savedApp.airLostTimeRTWInformation.lostTimeRTWInformationId
      currentState.loseTimeFromWork.value = savedApp.airLostTimeRTWInformation.didEmployeeLoseTimeFromWorkDueToInjury ? "Yes" : "No"
      if (savedApp.airLostTimeRTWInformation.lastDayWorkedDate)
        currentState.lastDayWorkedDate.value = moment(savedApp.airLostTimeRTWInformation.lastDayWorkedDate).toDate()
      if (savedApp.airLostTimeRTWInformation && savedApp.airLostTimeRTWInformation.lastDayWorkedDate) {
        // currentState.lastDayWorkTime.value = savedApp.airLostTimeRTWInformation.lastDayWorkedDate ? moment(savedApp.airLostTimeRTWInformation.lastDayWorkedDate) : currentState.lastDayWorkTime.value
        // currentState.lastDayWorkTime.value = savedApp.airLostTimeRTWInformation.lastDayWorkedDate ? (parseInt(savedApp.airLostTimeRTWInformation.lastDayWorkedDate.toString().split("T")[1].split(":")[0])<12?savedApp.airLostTimeRTWInformation.lastDayWorkedDate.toString().split("T")[1].split(":")[0]:(savedApp.airLostTimeRTWInformation.lastDayWorkedDate.toString().split("T")[1].split(":")[0]-12)) + ":" + savedApp.airLostTimeRTWInformation.lastDayWorkedDate.toString().split("T")[1].split(":")[1] : currentState.lastDayWorkTime.value
        currentState.lastDayWorkTime.value = savedApp.airLostTimeRTWInformation.lastDayWorkedDate ? new Date('1970-01-01T' + savedApp.airLostTimeRTWInformation.lastDayWorkedDate.toString().split("T")[1] + 'Z')
          .toLocaleTimeString('en-US',
            { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
          ).split(" ")[0] : currentState.lastDayWorkTime.value

        // currentState.lastDayWorkTimeRadio.value = savedApp.airLostTimeRTWInformation.lastDayWorkedDate ? parseInt(savedApp.airLostTimeRTWInformation.lastDayWorkedDate.toString().split("T")[1].split(":")[0])<12?"AM":"PM":currentState.lastDayWorkTimeRadio.value;
        currentState.lastDayWorkTimeRadio.value = savedApp.airLostTimeRTWInformation.lastDayWorkedDate ? new Date('1970-01-01T' + savedApp.airLostTimeRTWInformation.lastDayWorkedDate.toString().split("T")[1] + 'Z')
          .toLocaleTimeString('en-US',
            { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
          ).split(" ")[1] : currentState.lastDayWorkTimeRadio.value;
      }
      currentState.hasRTW.value = savedApp.airLostTimeRTWInformation.hasEmployeeReturnedToWork ? "Yes" : "No"
      currentState.typeRTW.value = savedApp.airLostTimeRTWInformation.typeOfWorkReturned
      currentState.typeRTWExtra.value = savedApp.airLostTimeRTWInformation.typeOfWorkReturnedOtherDescription
      currentState.rtwDate.value = savedApp.airLostTimeRTWInformation.dateRTW ? moment(savedApp.airLostTimeRTWInformation.dateRTW).toDate() : null
      // currentState.rtwTime.value = savedApp.airLostTimeRTWInformation.dateRTW ? moment(savedApp.airLostTimeRTWInformation.dateRTW) : currentState.rtwTime.value
      // currentState.rtwTime.value = savedApp.airLostTimeRTWInformation.dateRTW ? (parseInt(savedApp.airLostTimeRTWInformation.dateRTW.toString().split("T")[1].split(":")[0])<12?savedApp.airLostTimeRTWInformation.dateRTW.toString().split("T")[1].split(":")[0]:(savedApp.airLostTimeRTWInformation.dateRTW.toString().split("T")[1].split(":")[0]-12)) + ":" + savedApp.airLostTimeRTWInformation.dateRTW.toString().split("T")[1].split(":")[1] : currentState.rtwTime.value
      currentState.rtwTime.value = savedApp.airLostTimeRTWInformation.dateRTW ? new Date('1970-01-01T' + savedApp.airLostTimeRTWInformation.dateRTW.toString().split("T")[1] + 'Z')
        .toLocaleTimeString('en-US',
          { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
        ).split(" ")[0] : currentState.rtwTime.value

      // currentState.rtwTimeRadio.value = savedApp.airLostTimeRTWInformation.dateRTW ? parseInt(savedApp.airLostTimeRTWInformation.dateRTW.toString().split("T")[1].split(":")[0])<12?"AM":"PM":currentState.rtwTimeRadio.value
      currentState.rtwTimeRadio.value = savedApp.airLostTimeRTWInformation.dateRTW ? new Date('1970-01-01T' + savedApp.airLostTimeRTWInformation.dateRTW.toString().split("T")[1] + 'Z')
        .toLocaleTimeString('en-US',
          { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
        ).split(" ")[1] : currentState.rtwTimeRadio.value

      //currentState.rtwQuestion1.value = savedApp.airLostTimeRTWInformation.hasEmployeeBeenContactedRegardingRTW ? "Yes" : "No"
      currentState.rtwQuestion2.value = savedApp.airLostTimeRTWInformation.haveYouBeenProvidedWorkRestrictionsInjury ? "Yes" : "No"
      currentState.rtwQuestion3.value = savedApp.airLostTimeRTWInformation.isTheEmployeeWillingToReturnToModifiedWork ? "Yes" : "No"
      currentState.rtwQuestion3Extra.value = savedApp.airLostTimeRTWInformation.isTheEmployeeWillingToReturnToModifiedWorkDescription
      currentState.rtwQuestion4.value = savedApp.airLostTimeRTWInformation.hasModifiedWorkDiscussedOffered ? "Yes" : "No"
      currentState.rtwQuestion5.value = savedApp.airLostTimeRTWInformation.wereModifiedDutiesAccepted ? "Yes" : "No"
      currentState.rtwQuestion6.value = savedApp.airLostTimeRTWInformation.haveWorkHoursChanged
      currentState.rtwQuestion7.value = savedApp.airLostTimeRTWInformation.didPayRateChange
      if (savedApp.airLostTimeRTWInformation && savedApp.airLostTimeRTWInformation.dateStartedModifedDuties)
        currentState.rtwQuestion5Extra.value = moment(savedApp.airLostTimeRTWInformation.dateStartedModifedDuties).toDate()
      currentState.whoIsResponsible.value = savedApp.airLostTimeRTWInformation.whoIsResponsible
      currentState.responsibleRTWName.value = savedApp.airLostTimeRTWInformation.responsibleForArrangingRTWName
      currentState.responsibleRTWTelephone.value = savedApp.airLostTimeRTWInformation.responsibleForArrangingRTWTelephone
    }
    if (savedApp.airAccidentDetails && savedApp.airAccidentDetails.accidentDetailsId) {
      state.accidentDetailsId.value = savedApp.airAccidentDetails.accidentDetailsId
      state.accidentDetailsQues1.value = savedApp.airAccidentDetails.placeLocationInjuryOccur
      state.accidentDetailsQues2.value = savedApp.airAccidentDetails.whatHappenedToCauseInjury
      state.accidentDetailsQues3.value = savedApp.airAccidentDetails.partOfTheBodyInjured
      state.accidentDetailsQues4.value = savedApp.airAccidentDetails.whatConditionsContributedToAccident
      //state.personInvolved.value = savedApp.airAccidentDetails.personInvolved
      state.equipmentInvolved.value = savedApp.airAccidentDetails.equipmentInvolved
      state.materialInvolved.value = savedApp.airAccidentDetails.materialInvolved
      state.environmentInvolved.value = savedApp.airAccidentDetails.environmentInvolved
      state.processInvolved.value = savedApp.airAccidentDetails.processInvolved
      //state.accidentDetailsQues5.value = savedApp.airAccidentDetails.commentsPreventionOfAsimilarAccident
      //state.accidentDetailsQues8.value = savedApp.airAccidentDetails.equipmentResponsibleForTheAccident
      state.accidentDetailsQues9.value = savedApp.airAccidentDetails.wearingAppropriateSafetyEuipment
      state.classificationOSHA.value = savedApp.airAccidentDetails.classificationOSHA
      state.leftOrRightHandDominant.value = savedApp.airAccidentDetails.leftOrRightHandDominant
      state.bodilyFluidHarmfulSubstanceExposure.value = savedApp.airAccidentDetails.bodilyFluidHarmfulSubstanceExposure
      state.relevantFacts.value = savedApp.airAccidentDetails.relavantFacts
      // state.eventType.value = savedApp.airAccidentDetails.eventType

      utilities.prepareOptionMulDis(props.i18nReducerLang == "en-US" ? EVENT_TYPE : EVENT_TYPE_FR, "ID", ["Val"]).map((eventType) => {
        if (eventType.value == savedApp.airAccidentDetails.eventType) {
          state.eventType.value = {
            "value": eventType.value,
            "label": eventType.value + " - " + eventType.value
          }
        }
      })
      state.identyfyDetailsForEquipmentMaterialInvolved.value = savedApp.airAccidentDetails.identyfyDetailsForEquipmentMaterialInvolved
    }

    setState((state) => {
      return {
        ...state,
        currentState
      };
    });


    props.setCurrentFormStep(savedApp.employeeInformation.stepsCompleted);
    props.closeRemoveModal();
  }


  /** Clearing Conditional Inputs */
  useEffect(() => {
    if (state.doesWorkShift.value == "No") {
      const name = "workShift"
      let updatedObj = state[name];
      updatedObj.value = []

      const nameExtra = "doesWorkShiftExtra"
      let updatedObjExtra = state[nameExtra];
      updatedObjExtra.value = ""

      setState((state) => {
        return {
          ...state,
          [name]: updatedObj,
          [nameExtra]: updatedObjExtra
        };
      });
    }
  }, [state.doesWorkShift.value])

  useEffect(() => {
    if (state.rtwQuestion5.value == "No") {
      const name = "rtwQuestion5Extra"
      let updatedObj = state[name];
      updatedObj.value = ""

      setState((state) => {
        return {
          ...state,
          [name]: updatedObj
        };
      });
    }
  }, [state.rtwQuestion5.value])

  useEffect(() => {
    const name = "descRestrictions"
    let updatedObj = state[name];
    updatedObj.value = ""

    setState((state) => {
      return {
        ...state,
        [name]: updatedObj
      };
    });

  }, [state.providedRestrictions.value])

  const changeRequiredForTime = (stateName, required, isDate = false) => {
    let updatedObj = state[stateName];
    // updatedObj["validation"] = {};


    updatedObj["validation"]["required"] = required;
    updatedObj["error"] = ""

    if (!required) {
      // updatedObj["validation"] = null
      delete updatedObj["validation"]["required"]
      updatedObj["error"] = ""
    }

    return updatedObj;
  }

  const changeRequired = (stateName, required, isDate = false) => {
    let updatedObj = state[stateName];
    updatedObj["validation"] = {};
    if (isDate) {
      updatedObj["validation"]["isDate"] = isDate;
    }
    else {
      updatedObj["validation"] = { required: required };
    }
    if (!required) {
      updatedObj["validation"] = null
      updatedObj["error"] = ""
    }

    return updatedObj;
  }

  const clearValue = (stateName) => {
    let updatedObj = state[stateName];
    updatedObj.value = "";

    return updatedObj;
  }

  const onFilterDrpChange = (selectedValue) => {
    setselectedValueSave(selectedValue);
    selectedValue ? setSelectedCompanyDrp(true) : setSelectedCompanyDrp(false);
    // let locationStr = ""
    // if (selectedValue && selectedValue.departmentId > 0)
    //   if (props.location.findIndex(x => x.coLocationID_PK == selectedValue.departmentId) >= 0)
    //     locationStr = props.location.find(x => x.coLocationID_PK == selectedValue.departmentId).locationName
    setState((state) => {
      return {
        ...state,
        employeeFirstName: setValueToState("employeeFirstName", selectedValue ? selectedValue.clientFirstName : ""),
        employeeLastName: setValueToState("employeeLastName", selectedValue ? selectedValue.clientLastName : ""),
        dateOfBirth: setDateValueToState("dateOfBirth", selectedValue && selectedValue.dob ? moment(selectedValue.dob).toDate() : null),
        employeeTelephone: setValueToState("employeeTelephone", selectedValue ? normalizeInput(selectedValue.homePhone, "") : ""),
        // alternativePhone: setValueToState("alternativePhone", selectedValue ? selectedValue.workPhone : ""),
        // ein: setValueToState("ein", selectedValue ? selectedValue.externalID : ""),
        // employeeEmail: setValueToState("employeeEmail", selectedValue ? selectedValue.emailAddress : ""),
        // street: setValueToState("street", selectedValue ? selectedValue.address1 + " " + selectedValue.address2 : ""),
        //department: setValueToState("department", selectedValue ? selectedValue.department : ""),
        employeePrefLang: setValueToState("employeePrefLang", selectedValue && (selectedValue.language ? selectedValue.language : "CFR")),
        postalCode: setValueToState("postalCode", selectedValue ? formatPostalCode(selectedValue.zip) : ""),
        city: setValueToState("city", selectedValue ? selectedValue.city : ""),
        employeeAddress1: setValueToState("employeeAddress1", selectedValue ? selectedValue.address1 : ""),
        employeeAddress2: setValueToState("employeeAddress2", selectedValue ? selectedValue.address2 : ""),
        // province: setValueToStateForDrp("province", selectedValue ? selectedValue.province : "", props.state, "provinceId", "province"),
        country: setValueToStateForDrpId("country", selectedValue ? selectedValue.countryId : "", props.country, "countryId", "countryId"),
        province: setValueToStateForDrpId("province", selectedValue ? selectedValue.provinceId : "", props.state, "provinceId", "provinceId"),
        location: setValueToStateForDrpId("location", selectedValue ? selectedValue.departmentId : "", props.location, "coLocationID_PK", "coLocationID_PK"),
        //  prefferedLanguage: setValueToStateForDrpById("prefferedLanguage", selectedValue ? selectedValue.language : "", decidePreferredLngDrp(), "LanguageId", "Language"),
        managerName: setValueToStateForDrp("managerName", selectedValue ? selectedValue.managerName : "", props.supervisorList, "supervisorID_PK", "primaryName"),
        employeeJobTitle: setValueToState("employeeJobTitle", selectedValue ? selectedValue.jobtitle : ""),
        gender: setValueToState("gender", selectedValue ? selectedValue.gender && selectedValue.gender == "M" ? "Male" : selectedValue.gender == "F" ? "Female" : "Undisclose" : state.gender.value),
        // nameOfWhomReported:setValueToState("nameOfWhomReported", selectedValue ? selectedValue.managerName : ""),
        // telephoneOfWhomReported:setValueToState("telephoneOfWhomReported", selectedValue ? selectedValue.managerPhone : ""),
        // ExtOfWhomReported:setValueToState("ExtOfWhomReported", selectedValue ? selectedValue.managerExt : ""),
        dateOfHire: setDateValueToState("dateOfHire", selectedValue && selectedValue.dateOfHire ? moment(selectedValue.dateOfHire).toDate() : null),
        employee: setValueToState("employee", selectedValue ? selectedValue.externalID : "")
        // companyName:props.companyName
      }
    })
  }

  const setDateValueToState = (key, valueToBeSet) => {
    let updatedObj = state[key];
    updatedObj.value = valueToBeSet;

    if (valueToBeSet) {
      updatedObj.isEditable = false;
    }
    else {
      updatedObj.isEditable = true;
    }
    return updatedObj;
  }

  const setValueToState = (key, valueToBeSet) => {
    let updatedObj = state[key];
    updatedObj.value = valueToBeSet ? valueToBeSet.trim() : "";

    if (valueToBeSet) {
      updatedObj.isEditable = false;
    }
    else {
      updatedObj.isEditable = true;
    }
    return updatedObj;
  }

  const setValueToStateForDrpById = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    let editableStatus = true;
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      let optionVal = option[optionsKey];
      if (optionVal.trim() === valueToBeSet) {
        updatedObj.value = [option[optionsKey]]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;
    return updatedObj;
  }

  const setValueToStateForDrp = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    let editableStatus = true;
    if (!valueToBeSet) {
      updatedObj.value = [];
    }
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      if (option[optionsValue].trim().toLowerCase() === valueToBeSet.trim().toLowerCase()) {
        updatedObj.value = [option[optionsKey]]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;
    return updatedObj;
  }

  const filterApplicationState = useSelector(
    (state) => state.filterReducer
  );

  const onCustomDropdownChange = (selectItems, event) => {
    let selectedValue = undefined;
    let updatedObj = state.eventType;
    updatedObj.value = selectItems && selectItems;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    setState((state) => {
      return {
        ...state,
        ["eventType"]: updatedObj,
      };
    });
  }

  const onFilterDropDownChange = (selectItems, event) => {
    onDiscard();

    let selectedValue = undefined;

    //Find The value  from array for binding
    Array.isArray(filterApplicationState.filterApplicationValues) &&
      filterApplicationState.filterApplicationValues.map((option, key) => {
        if (selectItems && selectItems.value === option.externalID) {
          selectedValue = option;
        }
      })

    onFilterDrpChange(selectedValue);

    let updatedObj = state.selectedFilterValue;
    updatedObj.value = selectItems;
    setState((state) => {
      return {
        ...state,
        selectedFilterValue: updatedObj,
      };
    });
  }

  useEffect(() => {
    if (props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature) {
      setState((state) => {
        return {
          ...state,
          ["employee"]: changeRequired("employee", true),
        };
      });
    }
  }, [props.profileReducer && props.profileReducer.companyServices])


  const handleQuestionChange = (event) => {
    handleChanges(event);
    let { name, value, checked, type } = event.target;
    let isRequired = value == "Yes";
    if (name == "accidentQues2") {
      setState((state) => {
        return {
          ...state,
          ["outsideCountry"]: changeRequired("outsideCountry", isRequired),
          ["outsideProvince"]: changeRequired("outsideProvince", isRequired),
          ["outsideCity"]: changeRequired("outsideCity", isRequired)
        };
      });
    }
    else if (name == "accidentQues3") {

      setState((state) => {
        return {
          ...state,
          ["responsibleName"]: changeRequired("responsibleName", isRequired),
          ["responsiblePhone"]: changeRequired("responsiblePhone", isRequired),
        };
      });
    }
    else if (name == "accidentQues4") {
      setState((state) => {
        return {
          ...state,
          ["accidentQues4Comment"]: changeRequired("accidentQues4Comment", isRequired),
        };
      });
    }
    else if (name == "accidentQues7") {
      setState((state) => {
        return {
          ...state,
          ["accidentQues7Comment"]: changeRequired("accidentQues7Comment", isRequired),
        };
      });
    }
    else if (name == "accidentQues9") {
      setState((state) => {
        return {
          ...state,
          ["accidentQues9Comment"]: changeRequired("accidentQues9Comment", isRequired),
        };
      });
    }
    else if (name == "accidentQues11") {
      setState((state) => {
        return {
          ...state,
          ["specifyCompanyPremices"]: changeRequired("specifyCompanyPremices", isRequired),
        };
      });
    }
    else if (name == "rtwQuestion3") {
      setState((state) => {
        return {
          ...state,
          ["rtwQuestion3Extra"]: changeRequired("rtwQuestion3Extra", isRequired),
        };
      });
    }
    else if (name == "wereThereAnyWitness") {
      setState((state) => {
        return {
          ...state,
          ["witnessName"]: changeRequired("witnessName", isRequired),
          ["witnessPosition"]: changeRequired("witnessPosition", isRequired),
          ["witnessWorkPhone"]: changeRequired("witnessWorkPhone", isRequired),
        };
      });
    }
    else if (name == "didHealthcareReceived") {
      setState((state) => {
        return {
          ...state,
          ["dateOfEmployerAboutMedicalTretmenet"]: changeRequired("dateOfEmployerAboutMedicalTretmenet", isRequired),
        };
      });
    }
    else if (name == "isFirstAidGiven") {
      setState((state) => {
        return {
          ...state,
          ["dateOfFirstAidGiven"]: changeRequired("dateOfFirstAidGiven", isRequired, true),
          ["firstAidAttendantName"]: changeRequired("firstAidAttendantName", isRequired),
        };
      });
    }
    else if (name == "providedRestrictions") {
      setState((state) => {
        return {
          ...state,
          ["descRestrictions"]: changeRequired("descRestrictions", isRequired),
        };
      });
    }
    else if (name == "hasRTW") {
      setState((state) => {
        return {
          ...state,
          ["rtwDate"]: changeRequired("rtwDate", isRequired, true),
          ["typeRTW"]: changeRequired("typeRTW", isRequired),
          ["rtwTime"]: changeRequiredForTime("rtwTime", isRequired)
        };
      });
    }
    else if (name == "accidentReported") {
      isRequired = state.accidentReported.value == "Manager"

      let accidentManager = state.accidentReportedManager;
      accidentManager.value = [];

      // setState((state) => {
      //   return {
      //     ...state,
      //     accidentReportedManager: accidentManager,
      //   }
      // })

      if (isRequired) {
        //Find The value  from array for binding
        let selectedValue = undefined;
        if (props.contiuedPendingApplicationObj && props.contiuedPendingApplicationObj.employeeInformation) {
          let selectedFilterValue = {
            label: props.contiuedPendingApplicationObj.employeeInformation.employeeLastName + " " + props.contiuedPendingApplicationObj.employeeInformation.employeeFirstName + " - " + props.contiuedPendingApplicationObj.employeeInformation.employeeNumber,
            value: props.contiuedPendingApplicationObj.employeeInformation.employeeNumber
          };
          Array.isArray(filterApplicationState.filterApplicationValues) &&
            filterApplicationState.filterApplicationValues.map((option, key) => {
              if (selectedFilterValue.value && selectedFilterValue.value === option.externalID) {
                selectedValue = option;
              }
            })
        }
        else {
          Array.isArray(filterApplicationState.filterApplicationValues) &&
            filterApplicationState.filterApplicationValues.map((option, key) => {
              if (state.selectedFilterValue.value && state.selectedFilterValue.value.value && state.selectedFilterValue.value.value) {
                if (state.selectedFilterValue.value.value && state.selectedFilterValue.value.value === option.externalID) {
                  selectedValue = option;
                }
              }

            })
        }

        if (selectedValue && selectedValue.managerName) {
          let flag = true;
          props.supervisorList.map((manager) => {
            if (manager.primaryName == selectedValue.managerName) {
              flag = false;
              setState((state) => {
                return {
                  ...state,
                  nameOfWhomReported: setValueToState("nameOfWhomReported", manager.primaryName),
                  telephoneOfWhomReported: setValueToState("telephoneOfWhomReported", normalizeInput(manager.primaryPhone, "")),
                  positionOfWhomReported: setValueToState("positionOfWhomReported", "Manager"),
                  showManager: false
                }
              })
              return;
            }
          })
          if (flag) {
            setState((state) => {
              return {
                ...state,
                ["accidentReportedManager"]: changeRequired("accidentReportedManager", isRequired),
                ["showManager"]: true
              };
            });
          }
          // setState((state) => {
          //   return {
          //     ...state,
          //     nameOfWhomReported: setValueToState("nameOfWhomReported", selectedValue ? selectedValue.managerName : ""),
          //     telephoneOfWhomReported: setValueToState("telephoneOfWhomReported", selectedValue ? normalizeInput(selectedValue.managerPhone, "") : ""),
          //     ExtOfWhomReported: setValueToState("ExtOfWhomReported", selectedValue ? selectedValue.managerExt : ""),
          //     showManager: false
          //   }
          // })

        }
        else {
          setState((state) => {
            return {
              ...state,
              ["accidentReportedManager"]: changeRequired("accidentReportedManager", isRequired),
              ["showManager"]: true
            };
          });
        }
      }
      // setState((state) => {
      //   return {
      //     ...state,
      //     ["accidentReportedManager"]: changeRequired("accidentReportedManager", isRequired),
      //   };
      // });
    }
    else if (name == "whoIsResponsible") {

      let updateObj = state.responsibleManager;
      updateObj.value = [];

      setState((state) => {
        return {
          ...state,
          responsibleManager: updateObj,
        };
      });

      isRequired = state.whoIsResponsible.value == "Manager"
      setState((state) => {
        return {
          ...state,
          // ["responsibleManager"]: changeRequired("responsibleManager", isRequired),
        };
      });
    }

  }

  switch (props?.stepCount) {
    case 1:
      return (
        <>
          <div className="Dashboard-Content">
            <DisplayEmployeeName context={props.context} />
            <Airsteps
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
          </div>
          {/* {props.airFormPdfLink ? (
            <div className="alert alertSuccess" role="alert">
              {props.context.t("AIR.form.label.text.download-success-link")}&nbsp;
              <a onClick={() => utilities.download(props.airFormPdfLink)}>
                Click here
              </a>
              {props.context.t("AIR.form.label.text.download-here")}

            </div>
          ) : null} */}


          <div className="alert alertInfo WC-label-text" role="alert">
            {props.context.t(
              "AIR-Employer-Information.form.investigation.report"
            )}
          </div>

          <EmployerInformation
            state={state}
            handleChanges={handleChanges}
            onDropDownChange={onDropDownChange}
            handlePhoneNumber={handlePhoneNumber}
            props={props}
            onSubmit={onSubmit}
            onFilterDropDownChange={onFilterDropDownChange}
            onFilterDrpChange={onFilterDrpChange}
          />
        </>
      );
    case 2:
      return (
        <>
          <div className="Dashboard-Content">
            <DisplayEmployeeName context={props.context} />
            <Airsteps
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
          </div>
          <EmployeeInformation
            state={state}
            country={props.country}
            previousStep={previousStep}
            onDateChange={onDateChange}
            handleChanges={handleChanges}
            handlePhoneNumber={handlePhoneNumber}
            handleSIN={handleSIN}
            onDropDownChange={onDropDownChange}
            props={props}
            onSubmit={onSubmit}
            resetAirApplicationUrl={props.resetAirApplicationUrl}
            onAddManager={onAddManager}
          />
        </>
      );
    case 3:
      return (
        <>
          <div className="Dashboard-Content">
            <DisplayEmployeeName context={props.context} />
            <Airsteps
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
          </div>

          <AccidentInformation
            i18nReducerLang={props.i18nReducerLang}
            state={state}
            previousStep={previousStep}
            onDateChange={onDateChange}
            handleChanges={handleChanges}
            handlePhoneNumber={handlePhoneNumber}
            onDropDownChange={onDropDownChange}
            onTimeChange={onTimeChange}
            props={props}
            onSubmit={onSubmit}
            handleQuestionChange={handleQuestionChange}
            handleWeekShift={handleWeekShift}
          />
        </>
      );
    case 4:
      return (
        <>
          <div className="Dashboard-Content">
            <DisplayEmployeeName context={props.context} />
            <Airsteps
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
          </div>
          <AccidentDetails
            i18nReducerLang={props.i18nReducerLang}
            onCustomDropdownChange={onCustomDropdownChange}
            state={state}
            onSubmit={onSubmit}
            previousStep={previousStep}
            onDateChange={onDateChange}
            handleChanges={handleChanges}
            handlePhoneNumber={handlePhoneNumber}
            onDropDownChange={onDropDownChange}
            onTimeChange={onTimeChange}
            props={props}
            handleFileUpload={handleFileUpload}
            addDescription={addDescription}
            download={download}
            removeFile={removeFile}
            attachmentRef={attachmentRef}
          />
        </>
      );
    case 5:
      return (
        <>
          <div className="Dashboard-Content">
            <DisplayEmployeeName context={props.context} />
            <Airsteps
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
          </div>
          <ReturnToWorkInformation
            handleFileUpload={handleFileUpload}
            addDescription={addDescription}
            download={download}
            removeFile={removeFile}
            attachmentRef={attachmentRef}
            state={state}
            onSubmit={onSubmit}
            previousStep={previousStep}
            onDateChange={onDateChange}
            handleChanges={handleChanges}
            handlePhoneNumber={handlePhoneNumber}
            onDropDownChange={onDropDownChange}
            onTimeChange={onTimeChange}
            props={props}
            handleQuestionChange={handleQuestionChange}
          />

        </>
      );
    default:
      return null;
  }
};
export default AirComponent;
